// // src/components/CoinleyCheckout.jsx - Updated with QR payment verification
// import React, { forwardRef, useImperativeHandle, useState, useEffect, useRef } from 'react';
// import { useCoinley } from '../context/CoinleyContext';
// import { useTheme } from '../context/ThemeContext';
// import CoinleyModal from './CoinleyModal';
// import { 
//   createPayment, 
//   processPayment, 
//   verifyQRPayment, // Add this import
//   getMerchantWallets, 
//   getMerchantFeePercentage,
//   getMerchantNetworks,
//   getMerchantTokens 
// } from '../services/api';
// import { 
//   connectWallet, 
//   sendTransaction, 
//   detectWallets, 
//   detectWalletsWithRetry,
//   getSupportedWalletsForNetwork,
//   debugWalletEnvironment,
//   NETWORK_TYPES,
//   WALLET_TYPES 
// } from '../services/walletService';

// /**
//  * Optimized Coinley checkout with QR payment verification
//  */
// const CoinleyCheckout = forwardRef(({ 
//   apiKey,
//   apiSecret,
//   apiUrl,
//   customerEmail,
//   merchantName = 'Merchant',
//   merchantWalletAddresses = {},
//   onSuccess,
//   onError,
//   onClose,
//   theme,
//   autoOpen = false,
//   debug = false,
//   testMode = false,
//   supportedNetworks = [],
//   preferredNetwork = NETWORK_TYPES.ETHEREUM,
//   preferredWallet = WALLET_TYPES.METAMASK,
//   confirmations = 1,
//   fastMode = true
// }, ref) => {
//   // Context
//   const coinleyContext = useCoinley();
//   const { theme: contextTheme } = useTheme();
  
//   // State
//   const [isOpen, setIsOpen] = useState(autoOpen);
//   const [payment, setPayment] = useState(null);
//   const [paymentStatus, setPaymentStatus] = useState('idle');
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
//   const [error, setError] = useState(null);
//   const [transactionHash, setTransactionHash] = useState(null);
//   const [walletConnection, setWalletConnection] = useState(null);
//   const [availableWallets, setAvailableWallets] = useState({});
//   const [step, setStep] = useState('select-currency');
//   const [actualMerchantWallets, setActualMerchantWallets] = useState({});
//   const [merchantFeePercentage, setMerchantFeePercentage] = useState(0.0175);
  
//   // New state for merchant's configured networks and tokens
//   const [merchantSupportedNetworks, setMerchantSupportedNetworks] = useState([]);
//   const [merchantSupportedTokens, setMerchantSupportedTokens] = useState([]);
  
//   // Processing state
//   const [processingStartTime, setProcessingStartTime] = useState(null);
//   const [checkingInterval, setCheckingInterval] = useState(null);
//   const processingTimerRef = useRef(null);
//   const [pendingBackendConfirmation, setPendingBackendConfirmation] = useState(false);
  
//   // Use the component props or fallback to context values
//   const effectiveApiKey = apiKey || coinleyContext?.apiKey;
//   const effectiveApiSecret = apiSecret || coinleyContext?.apiSecret;
//   const effectiveApiUrl = apiUrl || coinleyContext?.apiUrl;
//   const effectiveTheme = theme || contextTheme;
//   const effectiveDebug = debug || coinleyContext?.debug;

//   // Debug logging helper
//   const log = (message, data) => {
//     if (effectiveDebug) {
//       console.log(`[Coinley SDK] ${message}`, data);
//     }
//   };

//   // Fetch merchant data on component mount
//   useEffect(() => {
//     const fetchMerchantData = async () => {
//       try {
//         log('Fetching merchant data from backend...');
        
//         const [wallets, feePercentage, networks, tokens] = await Promise.all([
//           getMerchantWallets(),
//           getMerchantFeePercentage(),
//           getMerchantNetworks(),
//           getMerchantTokens()
//         ]);
        
//         setActualMerchantWallets(wallets);
//         setMerchantFeePercentage(feePercentage);
//         setMerchantSupportedNetworks(networks);
//         setMerchantSupportedTokens(tokens);
        
//         log('Merchant data fetched successfully:', { 
//           wallets, 
//           feePercentage: `${(feePercentage * 100).toFixed(2)}%`,
//           networksCount: networks.length,
//           tokensCount: tokens.length
//         });
//       } catch (error) {
//         console.error('Failed to fetch merchant data:', error);
//         setActualMerchantWallets(merchantWalletAddresses);
//         setMerchantFeePercentage(0.0175);
//         setMerchantSupportedNetworks([]);
//         setMerchantSupportedTokens([]);
//       }
//     };

//     if (effectiveApiKey && effectiveApiSecret) {
//       fetchMerchantData();
//     }
//   }, [effectiveApiKey, effectiveApiSecret, merchantWalletAddresses]);

//   // Check available wallets on mount with retry
//   useEffect(() => {
//     if (typeof window !== 'undefined') {
//       const detectWalletsAsync = async () => {
//         const wallets = await detectWalletsWithRetry(3, 1000);
//         setAvailableWallets(wallets);
//         log('Available wallets detected:', wallets);
//       };
      
//       detectWalletsAsync();
//     }
//   }, [effectiveDebug]);

//   // Cleanup processing timers and intervals on unmount
//   useEffect(() => {
//     return () => {
//       if (processingTimerRef.current) {
//         clearTimeout(processingTimerRef.current);
//       }
//       if (checkingInterval) {
//         clearInterval(checkingInterval);
//       }
//     };
//   }, [checkingInterval]);

//   // Backend confirmation function
//   const processBackendConfirmationWithDebug = async (txHash) => {
//     console.log('🔍 processBackendConfirmationWithDebug called with:', txHash);
    
//     if (!payment || !selectedPaymentMethod || !txHash) {
//       console.error('❌ Missing required data for backend confirmation');
//       return;
//     }
    
//     try {
//       const processResponse = await processPayment({
//         paymentId: payment.id,
//         transactionHash: txHash,
//         network: selectedPaymentMethod.network,
//         senderAddress: walletConnection?.address || 'QR_PAYMENT'
//       });

//       console.log('✅ Payment processed successfully with backend:', processResponse);
//       setPendingBackendConfirmation(false);
      
//       setPaymentStatus('success');
      
//       if (onSuccess) {
//         onSuccess(payment.id, txHash, {
//           network: selectedPaymentMethod.network,
//           currency: selectedPaymentMethod.currency,
//           amount: payment.totalAmount || payment.amount,
//           processResponse: processResponse
//         });
//       }
//     } catch (processError) {
//       console.error('❌ processBackendConfirmation failed:', processError);
//       setPendingBackendConfirmation(true);
      
//       setTimeout(() => {
//         console.log('🔄 Retrying processBackendConfirmation...');
//         processBackendConfirmationWithDebug(txHash);
//       }, 10000);
//     }
//   };

//   // NEW: QR Payment verification function
//   const handleQRPaymentVerification = async () => {
//     if (!payment) {
//       setError('Payment information is missing');
//       return;
//     }

//     setPaymentStatus('loading');
//     setStep('processing');
//     setProcessingStartTime(Date.now());
//     setError(null);

//     try {
//       log('Starting QR payment verification...');
      
//       const verificationResult = await verifyQRPayment(payment.id);
      
//       if (verificationResult.verified) {
//         log('QR payment verified successfully:', verificationResult);
        
//         setTransactionHash(verificationResult.payment.transactionHash);
//         setStep('success');
//         setPaymentStatus('success');
        
//         if (onSuccess) {
//           onSuccess(payment.id, verificationResult.payment.transactionHash, {
//             network: selectedPaymentMethod.network,
//             currency: selectedPaymentMethod.currency,
//             amount: verificationResult.payment.amount,
//             verificationType: 'QR_PAYMENT'
//           });
//         }
//       } else {
//         // Payment not found yet, show user-friendly message
//         setError(verificationResult.message || 'Transaction not detected yet. Please wait a moment and try again.');
//         setStep('confirm');
//         setPaymentStatus('idle');
//       }
//     } catch (error) {
//       log('QR payment verification error:', error);
//       setError(error.message || 'Failed to verify payment. Please try again.');
//       setStep('confirm');
//       setPaymentStatus('error');
//       if (onError) onError(error);
//     }
//   };

//   // Expose methods via ref
//   useImperativeHandle(ref, () => ({
//     open: (paymentDetails) => {
//       handleOpen(paymentDetails);
//     },
//     close: () => {
//       handleClose();
//     },
//     getPayment: () => payment,
//     getWalletConnection: () => walletConnection,
//     debugWallets: () => debugWalletEnvironment(),
//     getMerchantWallets: () => actualMerchantWallets,
//     getMerchantFeePercentage: () => merchantFeePercentage,
//     getMerchantSupportedNetworks: () => merchantSupportedNetworks,
//     getMerchantSupportedTokens: () => merchantSupportedTokens
//   }));

//   // Handle opening the payment modal
//   const handleOpen = async (paymentDetails) => {
//     if (!paymentDetails || !paymentDetails.amount) {
//       setError('Payment amount is required');
//       if (onError) onError(new Error('Payment amount is required'));
//       return;
//     }

//     setPaymentStatus('loading');
//     setIsOpen(true);
//     setStep('select-currency');

//     try {
//       log('Creating payment with details:', paymentDetails);
      
//       // Validate that the requested network is supported by merchant
//       if (paymentDetails.network) {
//         const isNetworkSupported = merchantSupportedNetworks.some(
//           network => network.shortName === paymentDetails.network
//         );
        
//         if (!isNetworkSupported) {
//           throw new Error(`Network ${paymentDetails.network} is not configured for this merchant`);
//         }
//       }
      
//       // Validate that the requested currency is supported by merchant
//       if (paymentDetails.currency && paymentDetails.network) {
//         const isTokenSupported = merchantSupportedTokens.some(
//           token => token.symbol === paymentDetails.currency && 
//                   token.Network && 
//                   token.Network.shortName === paymentDetails.network
//         );
        
//         if (!isTokenSupported) {
//           throw new Error(`Token ${paymentDetails.currency} is not supported on ${paymentDetails.network} network for this merchant`);
//         }
//       }
      
//       // Ensure we have the latest merchant wallet addresses
//       let walletAddresses = actualMerchantWallets;
//       if (Object.keys(walletAddresses).length === 0) {
//         log('No wallet addresses found, fetching from backend...');
//         walletAddresses = await getMerchantWallets();
//         setActualMerchantWallets(walletAddresses);
//       }

//       log('Using wallet addresses:', walletAddresses);

//       console.log('🚨 COINLEY CHECKOUT DEBUG:');
// console.log('paymentDetails:', paymentDetails);
// console.log('paymentDetails.network:', paymentDetails.network);
// console.log('preferredNetwork:', preferredNetwork);
// console.log('final network being sent:', paymentDetails.network || preferredNetwork);

//       // Create a payment on the Coinley backend
//       const paymentResponse = await createPayment({
//         amount: paymentDetails.amount,
//         currency: paymentDetails.currency || 'USDT',
//         network: paymentDetails.network || preferredNetwork,
//         customerEmail: paymentDetails.customerEmail || customerEmail,
//         callbackUrl: paymentDetails.callbackUrl,
//         metadata: {
//           ...paymentDetails.metadata,
//           merchantWalletAddresses: walletAddresses
//         },
//         merchantWalletAddresses: walletAddresses
//       });

//       log('Payment created:', paymentResponse);
      
//       // Use the fee percentage from the payment response
//       if (paymentResponse.payment.customFeePercentage) {
//         const feeFromPayment = parseFloat(paymentResponse.payment.customFeePercentage);
//         setMerchantFeePercentage(feeFromPayment);
//         log('Updated fee percentage from payment response:', `${(feeFromPayment * 100).toFixed(2)}%`);
//       }
      
//       setPayment(paymentResponse.payment);
//       setPaymentStatus('idle');
//       setError(null);
      
//       log('Payment created and state updated');
//     } catch (err) {
//       log('Error creating payment:', err);
//       setError(err.message || 'Failed to create payment');
//       setPaymentStatus('error');
//       if (onError) onError(err);
//     }
//   };

//   // Handle closing the modal
//   const handleClose = () => {
//     if (checkingInterval) {
//       clearInterval(checkingInterval);
//       setCheckingInterval(null);
//     }
    
//     if (processingTimerRef.current) {
//       clearTimeout(processingTimerRef.current);
//       processingTimerRef.current = null;
//     }
    
//     setIsOpen(false);
//     setTransactionHash(null);
//     setWalletConnection(null);
//     setSelectedPaymentMethod(null);
//     setStep('select-currency');
//     setProcessingStartTime(null);
//     setPendingBackendConfirmation(false);
    
//     if (onClose) onClose();
//   };

//   // Handle payment method selection
//   const handlePaymentMethodSelect = (paymentMethod) => {
//     console.log('=== PAYMENT METHOD SELECTION DEBUG ===');
//     console.log('1. Payment method selected:', paymentMethod);
//     console.log('2. Current step before:', step);
    
//     log('Payment method selected:', paymentMethod);
//     setSelectedPaymentMethod(paymentMethod);
    
//     setStep('confirm');
    
//     console.log('3. Step should now be: confirm');
//     console.log('=== END PAYMENT METHOD SELECTION DEBUG ===');
//   };

//   // Handle back navigation
//   const handleBack = () => {
//     if (step === 'confirm') {
//       setStep('select-currency');
//       setWalletConnection(null);
//     } else if (step === 'error') {
//       setStep('confirm');
//     }
//   };

//   // Enhanced wallet connection with retry and better debugging
//   const handleConnectWallet = async (walletType) => {
//     console.log('=== WALLET CONNECTION DEBUG ===');
//     console.log('1. Wallet type requested:', walletType);
//     console.log('2. Selected payment method:', selectedPaymentMethod);
//     console.log('3. Available wallets:', availableWallets);
//     console.log('4. Current step:', step);

//     if (!selectedPaymentMethod) {
//       console.error('No payment method selected');
//       setError('Please select a payment method first');
//       return;
//     }

//     try {
//       console.log('5. Attempting to connect wallet...');
//       setError(null);
      
//       log('Connecting wallet:', { walletType, network: selectedPaymentMethod.network });
      
//       const connection = await connectWallet(walletType, selectedPaymentMethod.network, 2);
//       setWalletConnection(connection);
//       setError(null);
      
//       console.log('6. Connection successful:', connection);
//       log('Wallet connected successfully:', connection);
//     } catch (err) {
//       console.error('7. Connection failed:', err);
//       log('Wallet connection error:', err);
//       setError(err.message || 'Failed to connect wallet');
//     }
    
//     console.log('=== END WALLET CONNECTION DEBUG ===');
//   };

//   // UPDATED: Handle payment submission with QR payment verification
//   const handlePayment = async (isQRPayment = false) => {
//     if (!payment || !selectedPaymentMethod) {
//       setError('Missing payment information');
//       return;
//     }

//     // NEW: Handle QR payment verification
//     if (isQRPayment) {
//       console.log('🔄 QR Payment - Starting verification process...');
//       await handleQRPaymentVerification();
//       return;
//     }

//     // Original wallet payment flow
//     if (!walletConnection && !testMode) {
//       setError('Please connect your wallet first');
//       return;
//     }

//     log('Starting payment process...');
//     setPaymentStatus('loading');
//     setTransactionHash(null);
//     setStep('processing');
    
//     setProcessingStartTime(Date.now());

//     try {
//       let txHash;

//       if (testMode) {
//         log('Test mode: Generating mock transaction...');
//         txHash = `test_${Date.now().toString(16)}_${Math.random().toString(16).substring(2, 10)}`;
        
//         await new Promise(resolve => setTimeout(resolve, 1000));
//       } else {
//         let merchantAddress;
        
//         if (payment.recipientWallet) {
//           merchantAddress = payment.recipientWallet;
//         } else if (actualMerchantWallets[selectedPaymentMethod.network]) {
//           merchantAddress = actualMerchantWallets[selectedPaymentMethod.network];
//         } else {
//           throw new Error(`No merchant wallet address found for ${selectedPaymentMethod.network} network`);
//         }

//         log('Using merchant address for payment:', merchantAddress);

//         log('Sending transaction through wallet...');
        
//         txHash = await sendTransaction(walletConnection, {
//           to: merchantAddress,
//           amount: payment.totalAmount || payment.amount,
//           tokenAddress: selectedPaymentMethod.tokenConfig?.address,
//           tokenDecimals: selectedPaymentMethod.tokenConfig?.decimals,
//           currency: selectedPaymentMethod.currency,
//           network: selectedPaymentMethod.network
//         });
//       }

//       console.log('🎉 TRANSACTION HASH OBTAINED:', txHash);
//       setTransactionHash(txHash);
      
//       console.log('📺 Setting step to success...');
//       setStep('success');
//       setPaymentStatus('success');
      
//       console.log('🔄 About to call processBackendConfirmation...');
      
//       try {
//         console.log('🚀 CALLING processBackendConfirmation...');
//         await processBackendConfirmationWithDebug(txHash);
//       } catch (processError) {
//         console.error('❌ processBackendConfirmation failed:', processError);
//       }
      
//     } catch (err) {
//       log('Payment error:', err);
//       setError(err.message || 'Failed to process payment');
//       setPaymentStatus('error');
//       setStep('error');
//       if (onError) onError(err);
//     }
//   };

//   // Get supported wallets for current network
//   const getSupportedWallets = () => {
//     if (!selectedPaymentMethod) return [];
//     return getSupportedWalletsForNetwork(selectedPaymentMethod.network);
//   };

//   // Filter supported networks based on merchant configuration
//   const getEffectiveSupportedNetworks = () => {
//     if (merchantSupportedNetworks.length === 0) {
//       // Fallback to provided supportedNetworks if merchant networks not loaded
//       return supportedNetworks.length > 0 ? supportedNetworks : Object.values(NETWORK_TYPES);
//     }
    
//     // Use merchant's configured networks
//     return merchantSupportedNetworks.map(network => network.shortName);
//   };

//   return (
//     <>
//       {isOpen && (
//         <CoinleyModal
//           isOpen={isOpen}
//           onClose={handleClose}
//           payment={payment}
//           paymentStatus={paymentStatus}
//           selectedPaymentMethod={selectedPaymentMethod}
//           onPaymentMethodSelect={handlePaymentMethodSelect}
//           onPayment={handlePayment}
//           onBack={handleBack}
//           error={error}
//           theme={effectiveTheme}
//           merchantName={merchantName}
//           transactionHash={transactionHash}
//           walletConnection={walletConnection}
//           onConnectWallet={handleConnectWallet}
//           testMode={testMode}
//           supportedNetworks={getEffectiveSupportedNetworks()}
//           availableWallets={availableWallets}
//           supportedWallets={getSupportedWallets()}
//           step={step}
//           merchantWalletAddresses={actualMerchantWallets}
//           debug={effectiveDebug}
//           // Processing info
//           processingStartTime={processingStartTime}
//           pendingBackendConfirmation={pendingBackendConfirmation}
//           paymentNetwork={selectedPaymentMethod?.network}
//           // Pass the dynamic fee percentage
//           merchantFeePercentage={merchantFeePercentage}
//         />
//       )}
//     </>
//   );
// });

// CoinleyCheckout.displayName = 'CoinleyCheckout';

// export default CoinleyCheckout;

























// // src/components/CoinleyCheckout.jsx
// import React, { forwardRef, useImperativeHandle, useState, useEffect, useRef } from 'react';
// import { useCoinley } from '../context/CoinleyContext';
// import { useTheme } from '../context/ThemeContext';
// import CoinleyModal from './CoinleyModal';
// import { 
//   createPayment, 
//   processPayment, 
//   verifyQRPayment,
//   getMerchantWallets, 
//   getMerchantFeePercentage,
//   getMerchantNetworks,
//   getMerchantTokens 
// } from '../services/api';
// import { 
//   connectWallet, 
//   sendTransaction, 
//   detectWallets, 
//   detectWalletsWithRetry,
//   getSupportedWalletsForNetwork,
//   debugWalletEnvironment,
//   NETWORK_TYPES,
//   WALLET_TYPES 
// } from '../services/walletService';

// /**
//  * Fixed Coinley checkout with proper payment flow
//  */
// const CoinleyCheckout = forwardRef(({ 
//   apiKey,
//   apiSecret,
//   apiUrl,
//   customerEmail,
//   merchantName = 'Merchant',
//   merchantWalletAddresses = {},
//   onSuccess,
//   onError,
//   onClose,
//   theme,
//   autoOpen = false,
//   debug = false,
//   testMode = false,
//   supportedNetworks = [],
//   preferredNetwork = NETWORK_TYPES.ETHEREUM,
//   preferredWallet = WALLET_TYPES.METAMASK,
//   confirmations = 1,
//   fastMode = true
// }, ref) => {
//   // Context
//   const coinleyContext = useCoinley();
//   const { theme: contextTheme } = useTheme();
  
//   // State
//   const [isOpen, setIsOpen] = useState(autoOpen);
//   const [payment, setPayment] = useState(null);
//   const [paymentStatus, setPaymentStatus] = useState('idle');
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
//   const [error, setError] = useState(null);
//   const [transactionHash, setTransactionHash] = useState(null);
//   const [walletConnection, setWalletConnection] = useState(null);
//   const [availableWallets, setAvailableWallets] = useState({});
//   const [step, setStep] = useState('select-currency');
//   const [actualMerchantWallets, setActualMerchantWallets] = useState({});
//   const [merchantFeePercentage, setMerchantFeePercentage] = useState(0.0175);
  
//   // ✅ NEW: Store original payment details
//   const [storedPaymentDetails, setStoredPaymentDetails] = useState(null);
  
//   // New state for merchant's configured networks and tokens
//   const [merchantSupportedNetworks, setMerchantSupportedNetworks] = useState([]);
//   const [merchantSupportedTokens, setMerchantSupportedTokens] = useState([]);
  
//   // Processing state
//   const [processingStartTime, setProcessingStartTime] = useState(null);
//   const [checkingInterval, setCheckingInterval] = useState(null);
//   const processingTimerRef = useRef(null);
//   const [pendingBackendConfirmation, setPendingBackendConfirmation] = useState(false);
  
//   // Use the component props or fallback to context values
//   const effectiveApiKey = apiKey || coinleyContext?.apiKey;
//   const effectiveApiSecret = apiSecret || coinleyContext?.apiSecret;
//   const effectiveApiUrl = apiUrl || coinleyContext?.apiUrl;
//   const effectiveTheme = theme || contextTheme;
//   const effectiveDebug = debug || coinleyContext?.debug;

//   // Debug logging helper
//   const log = (message, data) => {
//     if (effectiveDebug) {
//       console.log(`[Coinley SDK] ${message}`, data);
//     }
//   };

//   // Fetch merchant data on component mount
//   useEffect(() => {
//     const fetchMerchantData = async () => {
//       try {
//         log('Fetching merchant data from backend...');
        
//         const [wallets, feePercentage, networks, tokens] = await Promise.all([
//           getMerchantWallets(),
//           getMerchantFeePercentage(),
//           getMerchantNetworks(),
//           getMerchantTokens()
//         ]);
        
//         setActualMerchantWallets(wallets);
//         setMerchantFeePercentage(feePercentage);
//         setMerchantSupportedNetworks(networks);
//         setMerchantSupportedTokens(tokens);
        
//         log('Merchant data fetched successfully:', { 
//           wallets, 
//           feePercentage: `${(feePercentage * 100).toFixed(2)}%`,
//           networksCount: networks.length,
//           tokensCount: tokens.length
//         });
//       } catch (error) {
//         console.error('Failed to fetch merchant data:', error);
//         setActualMerchantWallets(merchantWalletAddresses);
//         setMerchantFeePercentage(0.0175);
//         setMerchantSupportedNetworks([]);
//         setMerchantSupportedTokens([]);
//       }
//     };

//     if (effectiveApiKey && effectiveApiSecret) {
//       fetchMerchantData();
//     }
//   }, [effectiveApiKey, effectiveApiSecret, merchantWalletAddresses]);

//   // Check available wallets on mount with retry
//   useEffect(() => {
//     if (typeof window !== 'undefined') {
//       const detectWalletsAsync = async () => {
//         const wallets = await detectWalletsWithRetry(3, 1000);
//         setAvailableWallets(wallets);
//         log('Available wallets detected:', wallets);
//       };
      
//       detectWalletsAsync();
//     }
//   }, [effectiveDebug]);

//   // Cleanup processing timers and intervals on unmount
//   useEffect(() => {
//     return () => {
//       if (processingTimerRef.current) {
//         clearTimeout(processingTimerRef.current);
//       }
//       if (checkingInterval) {
//         clearInterval(checkingInterval);
//       }
//     };
//   }, [checkingInterval]);

//   // Backend confirmation function
//   const processBackendConfirmationWithDebug = async (txHash) => {
//     console.log('🔍 processBackendConfirmationWithDebug called with:', txHash);
    
//     if (!payment || !selectedPaymentMethod || !txHash) {
//       console.error('❌ Missing required data for backend confirmation');
//       return;
//     }
    
//     try {
//       const processResponse = await processPayment({
//         paymentId: payment.id,
//         transactionHash: txHash,
//         network: selectedPaymentMethod.network,
//         senderAddress: walletConnection?.address || 'QR_PAYMENT'
//       });

//       console.log('✅ Payment processed successfully with backend:', processResponse);
//       setPendingBackendConfirmation(false);
      
//       setPaymentStatus('success');
      
//       if (onSuccess) {
//         onSuccess(payment.id, txHash, {
//           network: selectedPaymentMethod.network,
//           currency: selectedPaymentMethod.currency,
//           amount: payment.totalAmount || payment.amount,
//           processResponse: processResponse
//         });
//       }
//     } catch (processError) {
//       console.error('❌ processBackendConfirmation failed:', processError);
//       setPendingBackendConfirmation(true);
      
//       setTimeout(() => {
//         console.log('🔄 Retrying processBackendConfirmation...');
//         processBackendConfirmationWithDebug(txHash);
//       }, 10000);
//     }
//   };

//   // QR Payment verification function
//   const handleQRPaymentVerification = async () => {
//     if (!payment) {
//       setError('Payment information is missing');
//       return;
//     }

//     setPaymentStatus('loading');
//     setStep('processing');
//     setProcessingStartTime(Date.now());
//     setError(null);

//     try {
//       log('Starting QR payment verification...');
      
//       const verificationResult = await verifyQRPayment(payment.id);
      
//       if (verificationResult.verified) {
//         log('QR payment verified successfully:', verificationResult);
        
//         setTransactionHash(verificationResult.payment.transactionHash);
//         setStep('success');
//         setPaymentStatus('success');
        
//         if (onSuccess) {
//           onSuccess(payment.id, verificationResult.payment.transactionHash, {
//             network: selectedPaymentMethod.network,
//             currency: selectedPaymentMethod.currency,
//             amount: verificationResult.payment.amount,
//             verificationType: 'QR_PAYMENT'
//           });
//         }
//       } else {
//         // Payment not found yet, show user-friendly message
//         setError(verificationResult.message || 'Transaction not detected yet. Please wait a moment and try again.');
//         setStep('confirm');
//         setPaymentStatus('idle');
//       }
//     } catch (error) {
//       log('QR payment verification error:', error);
//       setError(error.message || 'Failed to verify payment. Please try again.');
//       setStep('confirm');
//       setPaymentStatus('error');
//       if (onError) onError(error);
//     }
//   };

//   // Expose methods via ref
//   useImperativeHandle(ref, () => ({
//     open: (paymentDetails) => {
//       handleOpen(paymentDetails);
//     },
//     close: () => {
//       handleClose();
//     },
//     getPayment: () => payment,
//     getWalletConnection: () => walletConnection,
//     debugWallets: () => debugWalletEnvironment(),
//     getMerchantWallets: () => actualMerchantWallets,
//     getMerchantFeePercentage: () => merchantFeePercentage,
//     getMerchantSupportedNetworks: () => merchantSupportedNetworks,
//     getMerchantSupportedTokens: () => merchantSupportedTokens
//   }));

//   // ✅ FIXED: Handle opening the payment modal - DON'T create payment yet
//   const handleOpen = async (paymentDetails) => {
//     console.log('🚨 HANDLE OPEN DEBUG - START');
//     console.log('paymentDetails received:', paymentDetails);
    
//     if (!paymentDetails || !paymentDetails.amount) {
//       setError('Payment amount is required');
//       if (onError) onError(new Error('Payment amount is required'));
//       return;
//     }

//     // ✅ Store payment details for later use when user selects payment method
//     setStoredPaymentDetails(paymentDetails);
//     setPaymentStatus('idle');
//     setIsOpen(true);
//     setStep('select-currency');
//     setError(null);
    
//     console.log('✅ Modal opened, waiting for user to select payment method');
//   };

//   // Handle closing the modal
//   const handleClose = () => {
//     if (checkingInterval) {
//       clearInterval(checkingInterval);
//       setCheckingInterval(null);
//     }
    
//     if (processingTimerRef.current) {
//       clearTimeout(processingTimerRef.current);
//       processingTimerRef.current = null;
//     }
    
//     setIsOpen(false);
//     setTransactionHash(null);
//     setWalletConnection(null);
//     setSelectedPaymentMethod(null);
//     setStoredPaymentDetails(null); // ✅ Clear stored details
//     setPayment(null); // ✅ Clear payment
//     setStep('select-currency');
//     setProcessingStartTime(null);
//     setPendingBackendConfirmation(false);
    
//     if (onClose) onClose();
//   };

//   // ✅ FIXED: Handle payment method selection - CREATE payment here
//   const handlePaymentMethodSelect = async (paymentMethod) => {
//     console.log('=== PAYMENT METHOD SELECTION DEBUG ===');
//     console.log('1. Payment method selected:', paymentMethod);
//     console.log('2. Stored payment details:', storedPaymentDetails);
    
//     if (!storedPaymentDetails) {
//       setError('Payment details are missing');
//       return;
//     }
    
//     log('Payment method selected:', paymentMethod);
//     setSelectedPaymentMethod(paymentMethod);
    
//     // 🚀 CREATE PAYMENT NOW with the selected network/currency
//     try {
//       setPaymentStatus('loading');
      
//       console.log('🚀 Creating payment with selected method:');
//       console.log('Network:', paymentMethod.network);
//       console.log('Currency:', paymentMethod.currency);
      
//       // Validate that the requested network is supported by merchant
//       const isNetworkSupported = merchantSupportedNetworks.some(
//         network => network.shortName === paymentMethod.network
//       );
      
//       if (!isNetworkSupported) {
//         throw new Error(`Network ${paymentMethod.network} is not configured for this merchant`);
//       }
      
//       // Validate that the requested currency is supported by merchant
//       const isTokenSupported = merchantSupportedTokens.some(
//         token => token.symbol === paymentMethod.currency && 
//                 token.Network && 
//                 token.Network.shortName === paymentMethod.network
//       );
      
//       if (!isTokenSupported) {
//         throw new Error(`Token ${paymentMethod.currency} is not supported on ${paymentMethod.network} network for this merchant`);
//       }
      
//       // Ensure we have the latest merchant wallet addresses
//       let walletAddresses = actualMerchantWallets;
//       if (Object.keys(walletAddresses).length === 0) {
//         log('No wallet addresses found, fetching from backend...');
//         walletAddresses = await getMerchantWallets();
//         setActualMerchantWallets(walletAddresses);
//       }

//       log('Using wallet addresses:', walletAddresses);

//       // ✅ Create payment with SELECTED network/currency
//       const paymentResponse = await createPayment({
//         amount: storedPaymentDetails.amount,
//         currency: paymentMethod.currency, // ✅ Use selected currency
//         network: paymentMethod.network,   // ✅ Use selected network
//         customerEmail: storedPaymentDetails.customerEmail || customerEmail,
//         callbackUrl: storedPaymentDetails.callbackUrl,
//         metadata: {
//           ...storedPaymentDetails.metadata,
//           merchantWalletAddresses: walletAddresses
//         },
//         merchantWalletAddresses: walletAddresses
//       });

//       console.log('✅ Payment created with correct network:', paymentResponse.payment);
      
//       // Use the fee percentage from the payment response
//       if (paymentResponse.payment.customFeePercentage) {
//         const feeFromPayment = parseFloat(paymentResponse.payment.customFeePercentage);
//         setMerchantFeePercentage(feeFromPayment);
//         log('Updated fee percentage from payment response:', `${(feeFromPayment * 100).toFixed(2)}%`);
//       }
      
//       setPayment(paymentResponse.payment);
//       setPaymentStatus('idle');
//       setError(null);
      
//       // Now proceed to confirm step
//       setStep('confirm');
      
//       log('Payment created and proceeding to confirmation');
//     } catch (err) {
//       log('Error creating payment:', err);
//       setError(err.message || 'Failed to create payment');
//       setPaymentStatus('error');
//       if (onError) onError(err);
//     }
    
//     console.log('=== END PAYMENT METHOD SELECTION DEBUG ===');
//   };

//   // Handle back navigation
//   const handleBack = () => {
//     if (step === 'confirm') {
//       setStep('select-currency');
//       setWalletConnection(null);
//       // ✅ Clear payment when going back to allow re-selection
//       setPayment(null);
//       setSelectedPaymentMethod(null);
//     } else if (step === 'error') {
//       setStep('confirm');
//     }
//   };

//   // Enhanced wallet connection with retry and better debugging
//   const handleConnectWallet = async (walletType) => {
//     console.log('=== WALLET CONNECTION DEBUG ===');
//     console.log('1. Wallet type requested:', walletType);
//     console.log('2. Selected payment method:', selectedPaymentMethod);
//     console.log('3. Available wallets:', availableWallets);
//     console.log('4. Current step:', step);

//     if (!selectedPaymentMethod) {
//       console.error('No payment method selected');
//       setError('Please select a payment method first');
//       return;
//     }

//     try {
//       console.log('5. Attempting to connect wallet...');
//       setError(null);
      
//       log('Connecting wallet:', { walletType, network: selectedPaymentMethod.network });
      
//       const connection = await connectWallet(walletType, selectedPaymentMethod.network, 2);
//       setWalletConnection(connection);
//       setError(null);
      
//       console.log('6. Connection successful:', connection);
//       log('Wallet connected successfully:', connection);
//     } catch (err) {
//       console.error('7. Connection failed:', err);
//       log('Wallet connection error:', err);
//       setError(err.message || 'Failed to connect wallet');
//     }
    
//     console.log('=== END WALLET CONNECTION DEBUG ===');
//   };

//   // Handle payment submission with QR payment verification
//   const handlePayment = async (isQRPayment = false) => {
//     if (!payment || !selectedPaymentMethod) {
//       setError('Missing payment information');
//       return;
//     }

//     // Handle QR payment verification
//     if (isQRPayment) {
//       console.log('🔄 QR Payment - Starting verification process...');
//       await handleQRPaymentVerification();
//       return;
//     }

//     // Original wallet payment flow
//     if (!walletConnection && !testMode) {
//       setError('Please connect your wallet first');
//       return;
//     }

//     log('Starting payment process...');
//     setPaymentStatus('loading');
//     setTransactionHash(null);
//     setStep('processing');
    
//     setProcessingStartTime(Date.now());

//     try {
//       let txHash;

//       if (testMode) {
//         log('Test mode: Generating mock transaction...');
//         txHash = `test_${Date.now().toString(16)}_${Math.random().toString(16).substring(2, 10)}`;
        
//         await new Promise(resolve => setTimeout(resolve, 1000));
//       } else {
//         let merchantAddress;
        
//         if (payment.recipientWallet) {
//           merchantAddress = payment.recipientWallet;
//         } else if (actualMerchantWallets[selectedPaymentMethod.network]) {
//           merchantAddress = actualMerchantWallets[selectedPaymentMethod.network];
//         } else {
//           throw new Error(`No merchant wallet address found for ${selectedPaymentMethod.network} network`);
//         }

//         log('Using merchant address for payment:', merchantAddress);

//         log('Sending transaction through wallet...');
        
//         txHash = await sendTransaction(walletConnection, {
//           to: merchantAddress,
//           amount: payment.totalAmount || payment.amount,
//           tokenAddress: selectedPaymentMethod.tokenConfig?.address,
//           tokenDecimals: selectedPaymentMethod.tokenConfig?.decimals,
//           currency: selectedPaymentMethod.currency,
//           network: selectedPaymentMethod.network
//         });
//       }

//       console.log('🎉 TRANSACTION HASH OBTAINED:', txHash);
//       setTransactionHash(txHash);
      
//       console.log('📺 Setting step to success...');
//       setStep('success');
//       setPaymentStatus('success');
      
//       console.log('🔄 About to call processBackendConfirmation...');
      
//       try {
//         console.log('🚀 CALLING processBackendConfirmation...');
//         await processBackendConfirmationWithDebug(txHash);
//       } catch (processError) {
//         console.error('❌ processBackendConfirmation failed:', processError);
//       }
      
//     } catch (err) {
//       log('Payment error:', err);
//       setError(err.message || 'Failed to process payment');
//       setPaymentStatus('error');
//       setStep('error');
//       if (onError) onError(err);
//     }
//   };

//   // Get supported wallets for current network
//   const getSupportedWallets = () => {
//     if (!selectedPaymentMethod) return [];
//     return getSupportedWalletsForNetwork(selectedPaymentMethod.network);
//   };

//   // Filter supported networks based on merchant configuration
//   const getEffectiveSupportedNetworks = () => {
//     if (merchantSupportedNetworks.length === 0) {
//       // Fallback to provided supportedNetworks if merchant networks not loaded
//       return supportedNetworks.length > 0 ? supportedNetworks : Object.values(NETWORK_TYPES);
//     }
    
//     // Use merchant's configured networks
//     return merchantSupportedNetworks.map(network => network.shortName);
//   };

//   return (
//     <>
//       {isOpen && (
//         <CoinleyModal
//           isOpen={isOpen}
//           onClose={handleClose}
//           payment={payment}
//           paymentStatus={paymentStatus}
//           selectedPaymentMethod={selectedPaymentMethod}
//           onPaymentMethodSelect={handlePaymentMethodSelect}
//           onPayment={handlePayment}
//           onBack={handleBack}
//           error={error}
//           theme={effectiveTheme}
//           merchantName={merchantName}
//           transactionHash={transactionHash}
//           walletConnection={walletConnection}
//           onConnectWallet={handleConnectWallet}
//           testMode={testMode}
//           supportedNetworks={getEffectiveSupportedNetworks()}
//           availableWallets={availableWallets}
//           supportedWallets={getSupportedWallets()}
//           step={step}
//           merchantWalletAddresses={actualMerchantWallets}
//           debug={effectiveDebug}
//           // Processing info
//           processingStartTime={processingStartTime}
//           pendingBackendConfirmation={pendingBackendConfirmation}
//           paymentNetwork={selectedPaymentMethod?.network}
//           // Pass the dynamic fee percentage
//           merchantFeePercentage={merchantFeePercentage}
//         />
//       )}
//     </>
//   );
// });

// CoinleyCheckout.displayName = 'CoinleyCheckout';

// export default CoinleyCheckout;















// // src/components/CoinleyCheckout.jsx 
// import React, { forwardRef, useImperativeHandle, useState, useEffect, useRef } from 'react';
// import { useCoinley } from '../context/CoinleyContext';
// import { useTheme } from '../context/ThemeContext';
// import CoinleyModal from './CoinleyModal';
// import { 
//   createPayment, 
//   processPayment, 
//   verifyQRPayment,
//   getMerchantWallets, 
//   getMerchantFeePercentage,
//   getMerchantNetworks,
//   getMerchantTokens 
// } from '../services/api';
// import { 
//   connectWallet, 
//   sendTransaction, 
//   detectWallets, 
//   detectWalletsWithRetry,
//   getSupportedWalletsForNetwork,
//   debugWalletEnvironment,
//   NETWORK_TYPES,
//   WALLET_TYPES,
//   detectWalletConflicts,
//   resolveWalletConflicts
// } from '../services/walletService';

// /**
//  * Enhanced Coinley checkout with advanced wallet conflict resolution
//  */
// const CoinleyCheckout = forwardRef(({ 
//   apiKey,
//   apiSecret,
//   apiUrl,
//   customerEmail,
//   merchantName = 'Merchant',
//   merchantWalletAddresses = {},
//   onSuccess,
//   onError,
//   onClose,
//   theme,
//   autoOpen = false,
//   debug = false,
//   testMode = false,
//   supportedNetworks = [],
//   preferredNetwork = NETWORK_TYPES.ETHEREUM,
//   preferredWallet = WALLET_TYPES.METAMASK,
//   confirmations = 1,
//   fastMode = true
// }, ref) => {
//   // Context
//   const coinleyContext = useCoinley();
//   const { theme: contextTheme } = useTheme();
  
//   // State
//   const [isOpen, setIsOpen] = useState(autoOpen);
//   const [payment, setPayment] = useState(null);
//   const [paymentStatus, setPaymentStatus] = useState('idle');
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
//   const [error, setError] = useState(null);
//   const [transactionHash, setTransactionHash] = useState(null);
//   const [walletConnection, setWalletConnection] = useState(null);
//   const [availableWallets, setAvailableWallets] = useState({});
//   const [step, setStep] = useState('select-currency');
//   const [actualMerchantWallets, setActualMerchantWallets] = useState({});
//   const [merchantFeePercentage, setMerchantFeePercentage] = useState(0.0175);
  
//   // Store original payment details
//   const [storedPaymentDetails, setStoredPaymentDetails] = useState(null);
  
//   // New state for merchant's configured networks and tokens
//   const [merchantSupportedNetworks, setMerchantSupportedNetworks] = useState([]);
//   const [merchantSupportedTokens, setMerchantSupportedTokens] = useState([]);
  
//   // Processing state
//   const [processingStartTime, setProcessingStartTime] = useState(null);
//   const [checkingInterval, setCheckingInterval] = useState(null);
//   const processingTimerRef = useRef(null);
//   const [pendingBackendConfirmation, setPendingBackendConfirmation] = useState(false);
  
//   // 🚨 ENHANCED: Wallet conflict state
//   const [walletConflicts, setWalletConflicts] = useState([]);
//   const [conflictResolutionAttempted, setConflictResolutionAttempted] = useState(false);
  
//   // Use the component props or fallback to context values
//   const effectiveApiKey = apiKey || coinleyContext?.apiKey;
//   const effectiveApiSecret = apiSecret || coinleyContext?.apiSecret;
//   const effectiveApiUrl = apiUrl || coinleyContext?.apiUrl;
//   const effectiveTheme = theme || contextTheme;
//   const effectiveDebug = debug || coinleyContext?.debug;

//   // Debug logging helper
//   const log = (message, data) => {
//     if (effectiveDebug) {
//       console.log(`[Coinley SDK] ${message}`, data);
//     }
//   };

//   // 🚨 ENHANCED: Wallet conflict detection and resolution on mount
//   useEffect(() => {
//     if (typeof window !== 'undefined') {
//       // Detect and resolve wallet conflicts immediately
//       console.log('🔧 Initializing wallet conflict detection...');
      
//       const conflicts = resolveWalletConflicts();
//       setWalletConflicts(conflicts);
      
//       if (conflicts.length > 0) {
//         console.warn('🚨 Wallet conflicts detected on component mount:');
//         conflicts.forEach(conflict => {
//           console.warn(`- [${conflict.severity}] ${conflict.message}`);
//           console.warn(`  Solution: ${conflict.solution}`);
//         });
        
//         // Show user-friendly error for critical conflicts
//         const criticalConflicts = conflicts.filter(c => c.severity === 'high');
//         if (criticalConflicts.length > 0) {
//           setError(`Wallet conflict detected: ${criticalConflicts[0].message}. ${criticalConflicts[0].solution}`);
//         }
//       }
      
//       setConflictResolutionAttempted(true);
      
//       // Enhanced wallet detection with conflict resolution
//       const detectWalletsAsync = async () => {
//         // Wait for all wallet injections and conflict resolution to complete
//         await new Promise(resolve => setTimeout(resolve, 1500));
        
//         const wallets = await detectWalletsWithRetry(3, 1000);
//         setAvailableWallets(wallets);
        
//         log('Available wallets detected after conflict resolution:', wallets);
        
//         // Debug wallet environment if debug mode is on
//         if (effectiveDebug) {
//           const debugInfo = debugWalletEnvironment();
//           log('Wallet environment debug info:', debugInfo);
//         }
//       };
      
//       detectWalletsAsync();
//     }
//   }, [effectiveDebug]);

//   // 🚨 ENHANCED: Error handling for wallet conflicts and connection issues
//   useEffect(() => {
//     const handleWalletError = (error) => {
//       const errorMessage = error.message || error.reason?.message || 'Unknown error';
      
//       // Handle specific wallet conflict errors
//       if (errorMessage.includes('phantom') || errorMessage.includes('Phantom')) {
//         console.error('🚨 Phantom wallet conflict detected:', error);
//         setError('Phantom wallet is interfering with other wallets. Please try disabling Phantom extension temporarily and refresh the page.');
//         return;
//       }
      
//       // Handle MetaMask hijacking
//       if (errorMessage.includes('hijack') || errorMessage.includes('conflict')) {
//         console.error('🚨 Wallet hijacking detected:', error);
//         setError('Wallet conflict detected. Please disable conflicting wallet extensions and refresh the page.');
//         return;
//       }
      
//       // Handle connection rejections
//       if (errorMessage.includes('rejected') || errorMessage.includes('denied')) {
//         console.warn('⚠️ User rejected wallet connection:', error);
//         setError('Connection rejected. Please approve the wallet connection to continue.');
//         return;
//       }
      
//       // Handle insufficient balance (but don't show to user - let wallet handle it)
//       if (errorMessage.includes('Insufficient') && errorMessage.includes('balance')) {
//         console.warn('⚠️ Balance check error (ignoring):', errorMessage);
//         return; // Don't show balance errors to user
//       }
      
//       // Handle timeout errors
//       if (errorMessage.includes('timeout') || errorMessage.includes('took too long')) {
//         console.error('🚨 Wallet timeout:', error);
//         setError('Wallet connection timed out. Please make sure your wallet is unlocked and try again.');
//         return;
//       }
      
//       // Generic wallet errors
//       if (errorMessage.includes('wallet') || errorMessage.includes('provider')) {
//         console.error('🚨 Wallet error:', error);
//         setError(`Wallet error: ${errorMessage}. Please try refreshing the page.`);
//         return;
//       }
//     };

//     // Listen for both error events and unhandled promise rejections
//     window.addEventListener('error', (e) => handleWalletError(e.error));
//     window.addEventListener('unhandledrejection', (e) => handleWalletError(e.reason));

//     return () => {
//       window.removeEventListener('error', handleWalletError);
//       window.removeEventListener('unhandledrejection', handleWalletError);
//     };
//   }, []);

//   // Fetch merchant data on component mount
//   useEffect(() => {
//     const fetchMerchantData = async () => {
//       try {
//         log('Fetching merchant data from backend...');
        
//         const [wallets, feePercentage, networks, tokens] = await Promise.all([
//           getMerchantWallets(),
//           getMerchantFeePercentage(),
//           getMerchantNetworks(),
//           getMerchantTokens()
//         ]);
        
//         setActualMerchantWallets(wallets);
//         setMerchantFeePercentage(feePercentage);
//         setMerchantSupportedNetworks(networks);
//         setMerchantSupportedTokens(tokens);
        
//         log('Merchant data fetched successfully:', { 
//           wallets, 
//           feePercentage: `${(feePercentage * 100).toFixed(2)}%`,
//           networksCount: networks.length,
//           tokensCount: tokens.length
//         });
//       } catch (error) {
//         console.error('Failed to fetch merchant data:', error);
//         setActualMerchantWallets(merchantWalletAddresses);
//         setMerchantFeePercentage(0.0175);
//         setMerchantSupportedNetworks([]);
//         setMerchantSupportedTokens([]);
//       }
//     };

//     if (effectiveApiKey && effectiveApiSecret) {
//       fetchMerchantData();
//     }
//   }, [effectiveApiKey, effectiveApiSecret, merchantWalletAddresses]);

//   // Cleanup processing timers and intervals on unmount
//   useEffect(() => {
//     return () => {
//       if (processingTimerRef.current) {
//         clearTimeout(processingTimerRef.current);
//       }
//       if (checkingInterval) {
//         clearInterval(checkingInterval);
//       }
//     };
//   }, [checkingInterval]);

//   // Backend confirmation function
//   const processBackendConfirmationWithDebug = async (txHash) => {
//     console.log('🔍 processBackendConfirmationWithDebug called with:', txHash);
    
//     if (!payment || !selectedPaymentMethod || !txHash) {
//       console.error('❌ Missing required data for backend confirmation');
//       return;
//     }
    
//     try {
//       const processResponse = await processPayment({
//         paymentId: payment.id,
//         transactionHash: txHash,
//         network: selectedPaymentMethod.network,
//         senderAddress: walletConnection?.address || 'QR_PAYMENT'
//       });

//       console.log('✅ Payment processed successfully with backend:', processResponse);
//       setPendingBackendConfirmation(false);
      
//       setPaymentStatus('success');
      
//       if (onSuccess) {
//         onSuccess(payment.id, txHash, {
//           network: selectedPaymentMethod.network,
//           currency: selectedPaymentMethod.currency,
//           amount: payment.totalAmount || payment.amount,
//           processResponse: processResponse
//         });
//       }
//     } catch (processError) {
//       console.error('❌ processBackendConfirmation failed:', processError);
//       setPendingBackendConfirmation(true);
      
//       setTimeout(() => {
//         console.log('🔄 Retrying processBackendConfirmation...');
//         processBackendConfirmationWithDebug(txHash);
//       }, 10000);
//     }
//   };

//   // QR Payment verification function
//   const handleQRPaymentVerification = async () => {
//     if (!payment) {
//       setError('Payment information is missing');
//       return;
//     }

//     setPaymentStatus('loading');
//     setStep('processing');
//     setProcessingStartTime(Date.now());
//     setError(null);

//     try {
//       log('Starting QR payment verification...');
      
//       const verificationResult = await verifyQRPayment(payment.id);
      
//       if (verificationResult.verified) {
//         log('QR payment verified successfully:', verificationResult);
        
//         setTransactionHash(verificationResult.payment.transactionHash);
//         setStep('success');
//         setPaymentStatus('success');
        
//         if (onSuccess) {
//           onSuccess(payment.id, verificationResult.payment.transactionHash, {
//             network: selectedPaymentMethod.network,
//             currency: selectedPaymentMethod.currency,
//             amount: verificationResult.payment.amount,
//             verificationType: 'QR_PAYMENT'
//           });
//         }
//       } else {
//         setError(verificationResult.message || 'Transaction not detected yet. Please wait a moment and try again.');
//         setStep('confirm');
//         setPaymentStatus('idle');
//       }
//     } catch (error) {
//       log('QR payment verification error:', error);
//       setError(error.message || 'Failed to verify payment. Please try again.');
//       setStep('confirm');
//       setPaymentStatus('error');
//       if (onError) onError(error);
//     }
//   };

//   // Expose methods via ref
//   useImperativeHandle(ref, () => ({
//     open: (paymentDetails) => {
//       handleOpen(paymentDetails);
//     },
//     close: () => {
//       handleClose();
//     },
//     getPayment: () => payment,
//     getWalletConnection: () => walletConnection,
//     debugWallets: () => debugWalletEnvironment(),
//     getMerchantWallets: () => actualMerchantWallets,
//     getMerchantFeePercentage: () => merchantFeePercentage,
//     getMerchantSupportedNetworks: () => merchantSupportedNetworks,
//     getMerchantSupportedTokens: () => merchantSupportedTokens,
//     // 🚨 NEW: Debug methods for conflict resolution
//     getWalletConflicts: () => walletConflicts,
//     resolveConflicts: () => {
//       const conflicts = resolveWalletConflicts();
//       setWalletConflicts(conflicts);
//       return conflicts;
//     }
//   }));

//   // Handle opening the payment modal
//   const handleOpen = async (paymentDetails) => {
//     console.log('🚨 HANDLE OPEN DEBUG - START');
//     console.log('paymentDetails received:', paymentDetails);
    
//     if (!paymentDetails || !paymentDetails.amount) {
//       setError('Payment amount is required');
//       if (onError) onError(new Error('Payment amount is required'));
//       return;
//     }

//     // Store payment details for later use when user selects payment method
//     setStoredPaymentDetails(paymentDetails);
//     setPaymentStatus('idle');
//     setIsOpen(true);
//     setStep('select-currency');
//     setError(null);
    
//     console.log('✅ Modal opened, waiting for user to select payment method');
//   };

//   // Handle closing the modal
//   const handleClose = () => {
//     if (checkingInterval) {
//       clearInterval(checkingInterval);
//       setCheckingInterval(null);
//     }
    
//     if (processingTimerRef.current) {
//       clearTimeout(processingTimerRef.current);
//       processingTimerRef.current = null;
//     }
    
//     setIsOpen(false);
//     setTransactionHash(null);
//     setWalletConnection(null);
//     setSelectedPaymentMethod(null);
//     setStoredPaymentDetails(null);
//     setPayment(null);
//     setStep('select-currency');
//     setProcessingStartTime(null);
//     setPendingBackendConfirmation(false);
    
//     if (onClose) onClose();
//   };

//   // Handle payment method selection
//   const handlePaymentMethodSelect = async (paymentMethod) => {
//     console.log('=== PAYMENT METHOD SELECTION DEBUG ===');
//     console.log('1. Payment method selected:', paymentMethod);
//     console.log('2. Stored payment details:', storedPaymentDetails);
    
//     if (!storedPaymentDetails) {
//       setError('Payment details are missing');
//       return;
//     }
    
//     log('Payment method selected:', paymentMethod);
//     setSelectedPaymentMethod(paymentMethod);
    
//     // Create payment with the selected network/currency
//     try {
//       setPaymentStatus('loading');
      
//       console.log('🚀 Creating payment with selected method:');
//       console.log('Network:', paymentMethod.network);
//       console.log('Currency:', paymentMethod.currency);
      
//       // Validate that the requested network is supported by merchant
//       const isNetworkSupported = merchantSupportedNetworks.some(
//         network => network.shortName === paymentMethod.network
//       );
      
//       if (!isNetworkSupported) {
//         throw new Error(`Network ${paymentMethod.network} is not configured for this merchant`);
//       }
      
//       // Validate that the requested currency is supported by merchant
//       const isTokenSupported = merchantSupportedTokens.some(
//         token => token.symbol === paymentMethod.currency && 
//                 token.Network && 
//                 token.Network.shortName === paymentMethod.network
//       );
      
//       if (!isTokenSupported) {
//         throw new Error(`Token ${paymentMethod.currency} is not supported on ${paymentMethod.network} network for this merchant`);
//       }
      
//       // Ensure we have the latest merchant wallet addresses
//       let walletAddresses = actualMerchantWallets;
//       if (Object.keys(walletAddresses).length === 0) {
//         log('No wallet addresses found, fetching from backend...');
//         walletAddresses = await getMerchantWallets();
//         setActualMerchantWallets(walletAddresses);
//       }

//       log('Using wallet addresses:', walletAddresses);

//       // Create payment with SELECTED network/currency
//       const paymentResponse = await createPayment({
//         amount: storedPaymentDetails.amount,
//         currency: paymentMethod.currency,
//         network: paymentMethod.network,
//         customerEmail: storedPaymentDetails.customerEmail || customerEmail,
//         callbackUrl: storedPaymentDetails.callbackUrl,
//         metadata: {
//           ...storedPaymentDetails.metadata,
//           merchantWalletAddresses: walletAddresses
//         },
//         merchantWalletAddresses: walletAddresses
//       });

//       console.log('✅ Payment created with correct network:', paymentResponse.payment);
      
//       // Use the fee percentage from the payment response
//       if (paymentResponse.payment.customFeePercentage) {
//         const feeFromPayment = parseFloat(paymentResponse.payment.customFeePercentage);
//         setMerchantFeePercentage(feeFromPayment);
//         log('Updated fee percentage from payment response:', `${(feeFromPayment * 100).toFixed(2)}%`);
//       }
      
//       setPayment(paymentResponse.payment);
//       setPaymentStatus('idle');
//       setError(null);
      
//       // Now proceed to confirm step
//       setStep('confirm');
      
//       log('Payment created and proceeding to confirmation');
//     } catch (err) {
//       log('Error creating payment:', err);
//       setError(err.message || 'Failed to create payment');
//       setPaymentStatus('error');
//       if (onError) onError(err);
//     }
    
//     console.log('=== END PAYMENT METHOD SELECTION DEBUG ===');
//   };

//   // Handle back navigation
//   const handleBack = () => {
//     if (step === 'confirm') {
//       setStep('select-currency');
//       setWalletConnection(null);
//       setPayment(null);
//       setSelectedPaymentMethod(null);
//     } else if (step === 'error') {
//       setStep('confirm');
//     }
//   };

//   // 🚨 ENHANCED: Wallet connection with advanced conflict resolution
//   const handleConnectWallet = async (walletType) => {
//     console.log('=== ENHANCED WALLET CONNECTION DEBUG ===');
//     console.log('1. Wallet type requested:', walletType);
//     console.log('2. Selected payment method:', selectedPaymentMethod);
//     console.log('3. Available wallets:', availableWallets);
//     console.log('4. Detected conflicts:', walletConflicts);
//     console.log('5. Conflict resolution attempted:', conflictResolutionAttempted);

//     if (!selectedPaymentMethod) {
//       console.error('No payment method selected');
//       setError('Please select a payment method first');
//       return;
//     }

//     try {
//       setError(null);
      
//       // 🚨 STEP 1: Detect and resolve conflicts FIRST
//       console.log('🔧 Step 1: Resolving wallet conflicts...');
//       const currentConflicts = resolveWalletConflicts();
//       setWalletConflicts(currentConflicts);
      
//       if (currentConflicts.length > 0) {
//         console.warn('⚠️ Active wallet conflicts detected:');
//         currentConflicts.forEach(conflict => {
//           console.warn(`- [${conflict.severity}] ${conflict.type}: ${conflict.message}`);
//         });
        
//         // Handle critical conflicts for MetaMask
//         if (walletType === WALLET_TYPES.METAMASK) {
//           const criticalConflicts = currentConflicts.filter(c => 
//             c.type === 'phantom_hijack_ethereum' || 
//             c.type === 'multiple_metamask_providers'
//           );
          
//           if (criticalConflicts.length > 0) {
//             const conflict = criticalConflicts[0];
//             setError(`Wallet conflict detected: ${conflict.message}. ${conflict.solution}`);
            
//             // Give user option to proceed anyway
//             console.warn('🚨 Critical conflict detected but proceeding with caution...');
//           }
//         }
//       }
      
//       // 🚨 STEP 2: Wait a bit for wallet injection to stabilize
//       console.log('⏳ Step 2: Waiting for wallet stabilization...');
//       await new Promise(resolve => setTimeout(resolve, 500));
      
//       // 🚨 STEP 3: Re-detect wallets after conflict resolution
//       console.log('🔍 Step 3: Re-detecting wallets...');
//       const updatedWallets = await detectWalletsWithRetry(2, 500);
//       setAvailableWallets(updatedWallets);
      
//       if (!updatedWallets[walletType]) {
//         throw new Error(`${walletType} wallet not detected. Please make sure it's installed and enabled.`);
//       }
      
//       // 🚨 STEP 4: Attempt connection with retries
//       console.log('🚀 Step 4: Attempting wallet connection...');
//       let connection;
//       let retries = 0;
//       const maxRetries = 3;
      
//       while (retries < maxRetries) {
//         try {
//           console.log(`🔄 Connection attempt ${retries + 1}/${maxRetries} for ${walletType}`);
          
//           connection = await connectWallet(walletType, selectedPaymentMethod.network);
          
//           // Verify the connection is for the right wallet
//           if (connection.walletType !== walletType) {
//             throw new Error(`Connected to ${connection.walletType} instead of ${walletType}`);
//           }
          
//           console.log('✅ Wallet connection successful:', {
//             type: connection.walletType,
//             address: connection.address,
//             network: connection.network
//           });
          
//           break; // Success, exit retry loop
          
//         } catch (connectionError) {
//           retries++;
//           console.warn(`❌ Attempt ${retries} failed:`, connectionError.message);
          
//           if (retries >= maxRetries) {
//             throw connectionError;
//           }
          
//           // Wait longer between retries for MetaMask conflicts
//           const delayMs = walletType === WALLET_TYPES.METAMASK ? 2000 : 1000;
//           console.log(`⏳ Waiting ${delayMs}ms before retry...`);
//           await new Promise(resolve => setTimeout(resolve, delayMs));
//         }
//       }
      
//       setWalletConnection(connection);
//       setError(null);
      
//       console.log('🎉 Wallet connected successfully!');
      
//     } catch (err) {
//       console.error('❌ Final wallet connection error:', err);
      
//       // Enhanced error messages with specific solutions
//       let errorMessage = err.message || 'Failed to connect wallet';
      
//       if (walletType === WALLET_TYPES.METAMASK) {
//         if (errorMessage.includes('Phantom') || errorMessage.includes('hijack')) {
//           errorMessage = 'Phantom wallet is interfering with MetaMask. Please disable Phantom extension temporarily, refresh the page, and try again.';
//         } else if (errorMessage.includes('timeout') || errorMessage.includes('took too long')) {
//           errorMessage = 'MetaMask connection timed out. Please unlock MetaMask, click the extension icon to ensure it\'s active, and try again.';
//         } else if (errorMessage.includes('rejected') || errorMessage.includes('denied')) {
//           errorMessage = 'Connection rejected. Please approve the connection in MetaMask and try again.';
//         } else if (errorMessage.includes('not detected')) {
//           errorMessage = 'MetaMask not detected. Please install MetaMask extension and refresh the page.';
//         }
//       } else if (walletType === WALLET_TYPES.PHANTOM) {
//         if (errorMessage.includes('not detected')) {
//           errorMessage = 'Phantom wallet not detected. Please install Phantom extension and refresh the page.';
//         }
//       }
      
//       setError(errorMessage);
      
//       // Log detailed error for debugging
//       if (effectiveDebug) {
//         console.error('Detailed connection error:', {
//           walletType,
//           originalError: err,
//           conflicts: walletConflicts,
//           availableWallets
//         });
//       }
//     }
//   };

//   // Enhanced payment handling
//   const handlePayment = async (isQRPayment = false) => {
//     if (!payment || !selectedPaymentMethod) {
//       setError('Missing payment information');
//       return;
//     }

//     // Handle QR payment verification
//     if (isQRPayment) {
//       console.log('🔄 QR Payment - Starting verification process...');
//       await handleQRPaymentVerification();
//       return;
//     }

//     // Original wallet payment flow
//     if (!walletConnection && !testMode) {
//       setError('Please connect your wallet first');
//       return;
//     }

//     log('Starting payment process...');
//     setPaymentStatus('loading');
//     setTransactionHash(null);
//     setStep('processing');
    
//     setProcessingStartTime(Date.now());

//     try {
//       let txHash;

//       if (testMode) {
//         log('Test mode: Generating mock transaction...');
//         txHash = `test_${Date.now().toString(16)}_${Math.random().toString(16).substring(2, 10)}`;
        
//         await new Promise(resolve => setTimeout(resolve, 1000));
//       } else {
//         let merchantAddress;
        
//         if (payment.recipientWallet) {
//           merchantAddress = payment.recipientWallet;
//         } else if (actualMerchantWallets[selectedPaymentMethod.network]) {
//           merchantAddress = actualMerchantWallets[selectedPaymentMethod.network];
//         } else {
//           throw new Error(`No merchant wallet address found for ${selectedPaymentMethod.network} network`);
//         }

//         log('Using merchant address for payment:', merchantAddress);
//         log('Sending transaction through wallet...');
        
//         // Enhanced transaction sending with better error handling
//         try {
//           txHash = await sendTransaction(walletConnection, {
//             to: merchantAddress,
//             amount: payment.totalAmount || payment.amount,
//             tokenAddress: selectedPaymentMethod.tokenConfig?.address,
//             tokenDecimals: selectedPaymentMethod.tokenConfig?.decimals,
//             currency: selectedPaymentMethod.currency,
//             network: selectedPaymentMethod.network
//           });
//         } catch (sendError) {
//           // Filter out balance check errors and retry
//           if (sendError.message && sendError.message.includes('Insufficient') && sendError.message.includes('balance')) {
//             console.warn('⚠️ Ignoring balance check error, letting wallet handle it:', sendError.message);
            
//             // Try sending again, the wallet will show the real error if there's insufficient balance
//             txHash = await sendTransaction(walletConnection, {
//               to: merchantAddress,
//               amount: payment.totalAmount || payment.amount,
//               tokenAddress: selectedPaymentMethod.tokenConfig?.address,
//               tokenDecimals: selectedPaymentMethod.tokenConfig?.decimals,
//               currency: selectedPaymentMethod.currency,
//               network: selectedPaymentMethod.network
//             });
//           } else {
//             throw sendError;
//           }
//         }
//       }

//       console.log('🎉 TRANSACTION HASH OBTAINED:', txHash);
//       setTransactionHash(txHash);
      
//       console.log('📺 Setting step to success...');
//       setStep('success');
//       setPaymentStatus('success');
      
//       console.log('🔄 About to call processBackendConfirmation...');
      
//       try {
//         console.log('🚀 CALLING processBackendConfirmation...');
//         await processBackendConfirmationWithDebug(txHash);
//       } catch (processError) {
//         console.error('❌ processBackendConfirmation failed:', processError);
//       }
      
//     } catch (err) {
//       log('Payment error:', err);
      
//       // Filter out balance check errors from user display
//       if (err.message && err.message.includes('Insufficient') && err.message.includes('balance')) {
//         setError('Please check your wallet balance and try again. Make sure you have sufficient tokens and network fees.');
//       } else if (err.message && err.message.includes('rejected')) {
//         setError('Transaction rejected by user. Please try again.');
//       } else if (err.message && err.message.includes('timeout')) {
//         setError('Transaction timed out. Please check your wallet and try again.');
//       } else {
//         setError(err.message || 'Failed to process payment');
//       }
      
//       setPaymentStatus('error');
//       setStep('error');
//       if (onError) onError(err);
//     }
//   };

//   // Get supported wallets for current network
//   const getSupportedWallets = () => {
//     if (!selectedPaymentMethod) return [];
//     return getSupportedWalletsForNetwork(selectedPaymentMethod.network);
//   };

//   // Filter supported networks based on merchant configuration
//   const getEffectiveSupportedNetworks = () => {
//     if (merchantSupportedNetworks.length === 0) {
//       return supportedNetworks.length > 0 ? supportedNetworks : Object.values(NETWORK_TYPES);
//     }
    
//     return merchantSupportedNetworks.map(network => network.shortName);
//   };

//   // 🚨 ENHANCED: Wallet conflict warning component
//   const WalletConflictWarning = () => {
//     if (walletConflicts.length === 0) return null;
    
//     const criticalConflicts = walletConflicts.filter(c => c.severity === 'high');
//     const warningConflicts = walletConflicts.filter(c => c.severity === 'medium');
    
//     return (
//       <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
//         <h4 className="text-sm font-medium text-yellow-800 mb-2 flex items-center">
//           ⚠️ Wallet Conflicts Detected
//           {criticalConflicts.length > 0 && (
//             <span className="ml-2 bg-red-100 text-red-700 text-xs px-2 py-1 rounded">
//               Critical
//             </span>
//           )}
//         </h4>
        
//         {criticalConflicts.map((conflict, index) => (
//           <div key={`critical-${index}`} className="bg-red-50 border border-red-200 rounded p-2 mb-2">
//             <div className="text-xs text-red-800 font-medium mb-1">
//               🚨 {conflict.type.replace(/_/g, ' ').toUpperCase()}
//             </div>
//             <div className="text-xs text-red-700 mb-1">
//               <strong>Problem:</strong> {conflict.message}
//             </div>
//             <div className="text-xs text-red-700">
//               <strong>Solution:</strong> {conflict.solution}
//             </div>
//           </div>
//         ))}
        
//         {warningConflicts.map((conflict, index) => (
//           <div key={`warning-${index}`} className="text-xs text-yellow-700 mb-2">
//             <div className="font-medium">⚠️ {conflict.type.replace(/_/g, ' ')}</div>
//             <div className="ml-4">
//               <strong>Issue:</strong> {conflict.message}<br />
//               <strong>Fix:</strong> {conflict.solution}
//             </div>
//           </div>
//         ))}
        
//         <div className="flex gap-2 mt-3">
//           <button
//             onClick={() => window.location.reload()}
//             className="text-xs bg-yellow-100 hover:bg-yellow-200 text-yellow-800 px-3 py-1 rounded border border-yellow-300"
//           >
//             Refresh Page
//           </button>
//           <button
//             onClick={() => {
//               const conflicts = resolveWalletConflicts();
//               setWalletConflicts(conflicts);
//               if (conflicts.length === 0) {
//                 setError(null);
//               }
//             }}
//             className="text-xs bg-blue-100 hover:bg-blue-200 text-blue-800 px-3 py-1 rounded border border-blue-300"
//           >
//             Try Auto-Fix
//           </button>
//         </div>
        
//         {effectiveDebug && (
//           <div className="mt-2 pt-2 border-t border-yellow-300">
//             <button
//               onClick={() => {
//                 const debugInfo = debugWalletEnvironment();
//                 console.log('=== WALLET DEBUG INFO ===', debugInfo);
//                 alert('Debug info logged to console');
//               }}
//               className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-700 px-2 py-1 rounded"
//             >
//               Debug Info
//             </button>
//           </div>
//         )}
//       </div>
//     );
//   };

//   return (
//     <>
//       {isOpen && (
//         <CoinleyModal
//           isOpen={isOpen}
//           onClose={handleClose}
//           payment={payment}
//           paymentStatus={paymentStatus}
//           selectedPaymentMethod={selectedPaymentMethod}
//           onPaymentMethodSelect={handlePaymentMethodSelect}
//           onPayment={handlePayment}
//           onBack={handleBack}
//           error={error}
//           theme={effectiveTheme}
//           merchantName={merchantName}
//           transactionHash={transactionHash}
//           walletConnection={walletConnection}
//           onConnectWallet={handleConnectWallet}
//           testMode={testMode}
//           supportedNetworks={getEffectiveSupportedNetworks()}
//           availableWallets={availableWallets}
//           supportedWallets={getSupportedWallets()}
//           step={step}
//           merchantWalletAddresses={actualMerchantWallets}
//           debug={effectiveDebug}
//           // Processing info
//           processingStartTime={processingStartTime}
//           pendingBackendConfirmation={pendingBackendConfirmation}
//           paymentNetwork={selectedPaymentMethod?.network}
//           // Pass the dynamic fee percentage
//           merchantFeePercentage={merchantFeePercentage}
//           // 🚨 Pass wallet conflict warning component
//           conflictWarning={<WalletConflictWarning />}
//           // 🚨 Pass conflict information
//           walletConflicts={walletConflicts}
//           conflictResolutionAttempted={conflictResolutionAttempted}
//         />
//       )}
//     </>
//   );
// });

// CoinleyCheckout.displayName = 'CoinleyCheckout';

// export default CoinleyCheckout;















// // coinley-sdk/src/components/CoinleyCheckout.jsx
// import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
// import { useCoinley } from '../context/CoinleyContext';
// import { useTheme } from '../context/ThemeContext';
// import CoinleyModal from './CoinleyModal';
// import { 
//   createPayment, 
//   processPayment, 
//   verifyQRPayment,
//   getMerchantWallets, 
//   getMerchantFeePercentage,
//   getMerchantNetworks,
//   getMerchantTokens 
// } from '../services/api';
// import { 
//   connectWallet, 
//   sendTransaction, 
//   detectWallets,
//   getSupportedWalletsForNetwork,
//   NETWORK_TYPES,
//   WALLET_TYPES
// } from '../services/walletService';

// /**
//  * Simplified Coinley checkout with Coinley Connect integration
//  */
// const CoinleyCheckout = forwardRef(({ 
//   apiKey,
//   apiSecret,
//   apiUrl,
//   customerEmail,
//   merchantName = 'Merchant',
//   merchantWalletAddresses = {},
//   onSuccess,
//   onError,
//   onClose,
//   theme,
//   autoOpen = false,
//   debug = false,
//   testMode = false,
//   supportedNetworks = [],
//   preferredNetwork = NETWORK_TYPES.ETHEREUM,
//   preferredWallet = WALLET_TYPES.METAMASK,
//   confirmations = 1,
//   fastMode = true
// }, ref) => {
//   // Context
//   const coinleyContext = useCoinley();
//   const { theme: contextTheme } = useTheme();
  
//   // State - Much simpler now!
//   const [isOpen, setIsOpen] = useState(autoOpen);
//   const [payment, setPayment] = useState(null);
//   const [paymentStatus, setPaymentStatus] = useState('idle');
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
//   const [error, setError] = useState(null);
//   const [transactionHash, setTransactionHash] = useState(null);
//   const [walletConnection, setWalletConnection] = useState(null);
//   const [availableWallets, setAvailableWallets] = useState({});
//   const [step, setStep] = useState('select-currency');
//   const [actualMerchantWallets, setActualMerchantWallets] = useState({});
//   const [merchantFeePercentage, setMerchantFeePercentage] = useState(0.0175);
//   const [storedPaymentDetails, setStoredPaymentDetails] = useState(null);
//   const [merchantSupportedNetworks, setMerchantSupportedNetworks] = useState([]);
//   const [merchantSupportedTokens, setMerchantSupportedTokens] = useState([]);
//   const [processingStartTime, setProcessingStartTime] = useState(null);
//   const [pendingBackendConfirmation, setPendingBackendConfirmation] = useState(false);
  
//   // Use the component props or fallback to context values
//   const effectiveApiKey = apiKey || coinleyContext?.apiKey;
//   const effectiveApiSecret = apiSecret || coinleyContext?.apiSecret;
//   const effectiveApiUrl = apiUrl || coinleyContext?.apiUrl;
//   const effectiveTheme = theme || contextTheme;
//   const effectiveDebug = debug || coinleyContext?.debug;

//   // Debug logging helper
//   const log = (message, data) => {
//     if (effectiveDebug) {
//       console.log(`[Coinley SDK] ${message}`, data);
//     }
//   };

//   // Detect wallets on mount - much simpler now
//   useEffect(() => {
//     const detectWalletsAsync = async () => {
//       try {
//         const wallets = await detectWallets();
//         setAvailableWallets(wallets);
//         log('Available wallets detected:', wallets);
//       } catch (error) {
//         console.error('Error detecting wallets:', error);
//         setAvailableWallets({}); // Fallback to empty
//       }
//     };
    
//     detectWalletsAsync();
//   }, [effectiveDebug]);

//   // Fetch merchant data on component mount
//   useEffect(() => {
//     const fetchMerchantData = async () => {
//       try {
//         log('Fetching merchant data from backend...');
        
//         const [wallets, feePercentage, networks, tokens] = await Promise.all([
//           getMerchantWallets(),
//           getMerchantFeePercentage(),
//           getMerchantNetworks(),
//           getMerchantTokens()
//         ]);
        
//         setActualMerchantWallets(wallets);
//         setMerchantFeePercentage(feePercentage);
//         setMerchantSupportedNetworks(networks);
//         setMerchantSupportedTokens(tokens);
        
//         log('Merchant data fetched successfully:', { 
//           wallets, 
//           feePercentage: `${(feePercentage * 100).toFixed(2)}%`,
//           networksCount: networks.length,
//           tokensCount: tokens.length
//         });
//       } catch (error) {
//         console.error('Failed to fetch merchant data:', error);
//         setActualMerchantWallets(merchantWalletAddresses);
//         setMerchantFeePercentage(0.0175);
//         setMerchantSupportedNetworks([]);
//         setMerchantSupportedTokens([]);
//       }
//     };

//     if (effectiveApiKey && effectiveApiSecret) {
//       fetchMerchantData();
//     }
//   }, [effectiveApiKey, effectiveApiSecret, merchantWalletAddresses]);

//   // Backend confirmation function
//   const processBackendConfirmationWithDebug = async (txHash) => {
//     console.log('🔍 processBackendConfirmationWithDebug called with:', txHash);
    
//     if (!payment || !selectedPaymentMethod || !txHash) {
//       console.error('❌ Missing required data for backend confirmation');
//       return;
//     }
    
//     try {
//       const processResponse = await processPayment({
//         paymentId: payment.id,
//         transactionHash: txHash,
//         network: selectedPaymentMethod.network,
//         senderAddress: walletConnection?.address || 'EXTERNAL_WALLET'
//       });

//       console.log('✅ Payment processed successfully with backend:', processResponse);
//       setPendingBackendConfirmation(false);
      
//       setPaymentStatus('success');
      
//       if (onSuccess) {
//         onSuccess(payment.id, txHash, {
//           network: selectedPaymentMethod.network,
//           currency: selectedPaymentMethod.currency,
//           amount: payment.totalAmount || payment.amount,
//           processResponse: processResponse
//         });
//       }
//     } catch (processError) {
//       console.error('❌ processBackendConfirmation failed:', processError);
//       setPendingBackendConfirmation(true);
      
//       setTimeout(() => {
//         console.log('🔄 Retrying processBackendConfirmation...');
//         processBackendConfirmationWithDebug(txHash);
//       }, 10000);
//     }
//   };

//   // QR Payment verification function
//   const handleQRPaymentVerification = async () => {
//     if (!payment) {
//       setError('Payment information is missing');
//       return;
//     }

//     setPaymentStatus('loading');
//     setStep('processing');
//     setProcessingStartTime(Date.now());
//     setError(null);

//     try {
//       log('Starting QR payment verification...');
      
//       const verificationResult = await verifyQRPayment(payment.id);
      
//       if (verificationResult.verified) {
//         log('QR payment verified successfully:', verificationResult);
        
//         setTransactionHash(verificationResult.payment.transactionHash);
//         setStep('success');
//         setPaymentStatus('success');
        
//         if (onSuccess) {
//           onSuccess(payment.id, verificationResult.payment.transactionHash, {
//             network: selectedPaymentMethod.network,
//             currency: selectedPaymentMethod.currency,
//             amount: verificationResult.payment.amount,
//             verificationType: 'QR_PAYMENT'
//           });
//         }
//       } else {
//         setError(verificationResult.message || 'Transaction not detected yet. Please wait a moment and try again.');
//         setStep('confirm');
//         setPaymentStatus('idle');
//       }
//     } catch (error) {
//       log('QR payment verification error:', error);
//       setError(error.message || 'Failed to verify payment. Please try again.');
//       setStep('confirm');
//       setPaymentStatus('error');
//       if (onError) onError(error);
//     }
//   };

//   // Expose methods via ref
//   useImperativeHandle(ref, () => ({
//     open: (paymentDetails) => {
//       handleOpen(paymentDetails);
//     },
//     close: () => {
//       handleClose();
//     },
//     getPayment: () => payment,
//     getWalletConnection: () => walletConnection,
//     getMerchantWallets: () => actualMerchantWallets,
//     getMerchantFeePercentage: () => merchantFeePercentage,
//     getMerchantSupportedNetworks: () => merchantSupportedNetworks,
//     getMerchantSupportedTokens: () => merchantSupportedTokens
//   }));

//   // Handle opening the payment modal
//   const handleOpen = async (paymentDetails) => {
//     console.log('🚨 HANDLE OPEN DEBUG - START');
//     console.log('paymentDetails received:', paymentDetails);
    
//     if (!paymentDetails || !paymentDetails.amount) {
//       setError('Payment amount is required');
//       if (onError) onError(new Error('Payment amount is required'));
//       return;
//     }

//     setStoredPaymentDetails(paymentDetails);
//     setPaymentStatus('idle');
//     setIsOpen(true);
//     setStep('select-currency');
//     setError(null);
    
//     console.log('✅ Modal opened, waiting for user to select payment method');
//   };

//   // Handle closing the modal
//   const handleClose = () => {
//     setIsOpen(false);
//     setTransactionHash(null);
//     setWalletConnection(null);
//     setSelectedPaymentMethod(null);
//     setStoredPaymentDetails(null);
//     setPayment(null);
//     setStep('select-currency');
//     setProcessingStartTime(null);
//     setPendingBackendConfirmation(false);
    
//     if (onClose) onClose();
//   };

//   // Handle payment method selection
//   const handlePaymentMethodSelect = async (paymentMethod) => {
//     console.log('=== PAYMENT METHOD SELECTION DEBUG ===');
//     console.log('1. Payment method selected:', paymentMethod);
//     console.log('2. Stored payment details:', storedPaymentDetails);
    
//     if (!storedPaymentDetails) {
//       setError('Payment details are missing');
//       return;
//     }
    
//     log('Payment method selected:', paymentMethod);
//     setSelectedPaymentMethod(paymentMethod);
    
//     // Create payment with the selected network/currency
//     try {
//       setPaymentStatus('loading');
      
//       console.log('🚀 Creating payment with selected method:');
//       console.log('Network:', paymentMethod.network);
//       console.log('Currency:', paymentMethod.currency);
      
//       // Validate that the requested network is supported by merchant
//       const isNetworkSupported = merchantSupportedNetworks.some(
//         network => network.shortName === paymentMethod.network
//       );
      
//       if (!isNetworkSupported) {
//         throw new Error(`Network ${paymentMethod.network} is not configured for this merchant`);
//       }
      
//       // Validate that the requested currency is supported by merchant
//       const isTokenSupported = merchantSupportedTokens.some(
//         token => token.symbol === paymentMethod.currency && 
//                 token.Network && 
//                 token.Network.shortName === paymentMethod.network
//       );
      
//       if (!isTokenSupported) {
//         throw new Error(`Token ${paymentMethod.currency} is not supported on ${paymentMethod.network} network for this merchant`);
//       }
      
//       // Ensure we have the latest merchant wallet addresses
//       let walletAddresses = actualMerchantWallets;
//       if (Object.keys(walletAddresses).length === 0) {
//         log('No wallet addresses found, fetching from backend...');
//         walletAddresses = await getMerchantWallets();
//         setActualMerchantWallets(walletAddresses);
//       }

//       log('Using wallet addresses:', walletAddresses);

//       // Create payment with SELECTED network/currency
//       const paymentResponse = await createPayment({
//         amount: storedPaymentDetails.amount,
//         currency: paymentMethod.currency,
//         network: paymentMethod.network,
//         customerEmail: storedPaymentDetails.customerEmail || customerEmail,
//         callbackUrl: storedPaymentDetails.callbackUrl,
//         metadata: {
//           ...storedPaymentDetails.metadata,
//           merchantWalletAddresses: walletAddresses
//         },
//         merchantWalletAddresses: walletAddresses
//       });

//       console.log('✅ Payment created with correct network:', paymentResponse.payment);
      
//       // Use the fee percentage from the payment response
//       if (paymentResponse.payment.customFeePercentage) {
//         const feeFromPayment = parseFloat(paymentResponse.payment.customFeePercentage);
//         setMerchantFeePercentage(feeFromPayment);
//         log('Updated fee percentage from payment response:', `${(feeFromPayment * 100).toFixed(2)}%`);
//       }
      
//       setPayment(paymentResponse.payment);
//       setPaymentStatus('idle');
//       setError(null);
      
//       // Now proceed to confirm step
//       setStep('confirm');
      
//       log('Payment created and proceeding to confirmation');
//     } catch (err) {
//       log('Error creating payment:', err);
//       setError(err.message || 'Failed to create payment');
//       setPaymentStatus('error');
//       if (onError) onError(err);
//     }
    
//     console.log('=== END PAYMENT METHOD SELECTION DEBUG ===');
//   };

//   // Handle back navigation
//   const handleBack = () => {
//     if (step === 'confirm') {
//       setStep('select-currency');
//       setWalletConnection(null);
//       setPayment(null);
//       setSelectedPaymentMethod(null);
//     } else if (step === 'error') {
//       setStep('confirm');
//     }
//   };

//   // SIMPLIFIED: Wallet connection via Coinley Connect
//   const handleConnectWallet = async (walletType) => {
//     console.log('🔗 Connecting wallet via Coinley Connect:', walletType);

//     if (!selectedPaymentMethod) {
//       console.error('No payment method selected');
//       setError('Please select a payment method first');
//       return;
//     }

//     try {
//       setError(null);
      
//       // Use the simplified connectWallet function
//       const connection = await connectWallet(walletType, selectedPaymentMethod.network);
      
//       setWalletConnection(connection);
//       setError(null);
      
//       console.log('🎉 Wallet connected successfully via Coinley Connect!', connection);
      
//     } catch (err) {
//       console.error('❌ Wallet connection error:', err);
//       setError(err.message || 'Failed to connect wallet');
//     }
//   };

//   // SIMPLIFIED: Payment handling via Coinley Connect
//   const handlePayment = async (isQRPayment = false) => {
//     if (!payment || !selectedPaymentMethod) {
//       setError('Missing payment information');
//       return;
//     }

//     // Handle QR payment verification
//     if (isQRPayment) {
//       console.log('🔄 QR Payment - Starting verification process...');
//       await handleQRPaymentVerification();
//       return;
//     }

//     // Wallet payment flow via Coinley Connect
//     if (!walletConnection && !testMode) {
//       setError('Please connect your wallet first');
//       return;
//     }

//     log('Starting payment process via Coinley Connect...');
//     setPaymentStatus('loading');
//     setTransactionHash(null);
//     setStep('processing');
//     setProcessingStartTime(Date.now());

//     try {
//       let txHash;

//       if (testMode) {
//         log('Test mode: Generating mock transaction...');
//         txHash = `test_${Date.now().toString(16)}_${Math.random().toString(16).substring(2, 10)}`;
//         await new Promise(resolve => setTimeout(resolve, 1000));
//       } else {
//         let merchantAddress;
        
//         if (payment.recipientWallet) {
//           merchantAddress = payment.recipientWallet;
//         } else if (actualMerchantWallets[selectedPaymentMethod.network]) {
//           merchantAddress = actualMerchantWallets[selectedPaymentMethod.network];
//         } else {
//           throw new Error(`No merchant wallet address found for ${selectedPaymentMethod.network} network`);
//         }

//         log('Using merchant address for payment:', merchantAddress);
//         log('Sending transaction through Coinley Connect...');
        
//         // Use the simplified sendTransaction function
//         txHash = await sendTransaction(walletConnection, {
//           to: merchantAddress,
//           amount: payment.totalAmount || payment.amount,
//           tokenAddress: selectedPaymentMethod.tokenConfig?.address,
//           tokenDecimals: selectedPaymentMethod.tokenConfig?.decimals,
//           currency: selectedPaymentMethod.currency,
//           network: selectedPaymentMethod.network
//         });
//       }

//       console.log('🎉 TRANSACTION HASH OBTAINED:', txHash);
//       setTransactionHash(txHash);
      
//       console.log('📺 Setting step to success...');
//       setStep('success');
//       setPaymentStatus('success');
      
//       console.log('🔄 About to call processBackendConfirmation...');
      
//       try {
//         console.log('🚀 CALLING processBackendConfirmation...');
//         await processBackendConfirmationWithDebug(txHash);
//       } catch (processError) {
//         console.error('❌ processBackendConfirmation failed:', processError);
//       }
      
//     } catch (err) {
//       log('Payment error:', err);
//       setError(err.message || 'Failed to process payment');
//       setPaymentStatus('error');
//       setStep('error');
//       if (onError) onError(err);
//     }
//   };

//   // Get supported wallets for current network
//   const getSupportedWallets = () => {
//     if (!selectedPaymentMethod) return [];
//     return getSupportedWalletsForNetwork(selectedPaymentMethod.network);
//   };

//   // Filter supported networks based on merchant configuration
//   const getEffectiveSupportedNetworks = () => {
//     if (merchantSupportedNetworks.length === 0) {
//       return supportedNetworks.length > 0 ? supportedNetworks : Object.values(NETWORK_TYPES);
//     }
    
//     return merchantSupportedNetworks.map(network => network.shortName);
//   };

//   return (
//     <>
//       {isOpen && (
//         <CoinleyModal
//           isOpen={isOpen}
//           onClose={handleClose}
//           payment={payment}
//           paymentStatus={paymentStatus}
//           selectedPaymentMethod={selectedPaymentMethod}
//           onPaymentMethodSelect={handlePaymentMethodSelect}
//           onPayment={handlePayment}
//           onBack={handleBack}
//           error={error}
//           theme={effectiveTheme}
//           merchantName={merchantName}
//           transactionHash={transactionHash}
//           walletConnection={walletConnection}
//           onConnectWallet={handleConnectWallet}
//           testMode={testMode}
//           supportedNetworks={getEffectiveSupportedNetworks()}
//           availableWallets={availableWallets}
//           supportedWallets={getSupportedWallets()}
//           step={step}
//           merchantWalletAddresses={actualMerchantWallets}
//           debug={effectiveDebug}
//           processingStartTime={processingStartTime}
//           pendingBackendConfirmation={pendingBackendConfirmation}
//           paymentNetwork={selectedPaymentMethod?.network}
//           merchantFeePercentage={merchantFeePercentage}
//         />
//       )}
//     </>
//   );
// });

// CoinleyCheckout.displayName = 'CoinleyCheckout';

// export default CoinleyCheckout;







// coinley-sdk/src/components/CoinleyCheckout.jsx - Updated with wallet-connect-core integration
import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import { useCoinley } from '../context/CoinleyContext';
import { useTheme } from '../context/ThemeContext';
import CoinleyModal from './CoinleyModal';
import { 
  createPayment, 
  processPayment, 
  verifyQRPayment,
  getMerchantWallets, 
  getMerchantFeePercentage,
  getMerchantNetworks,
  getMerchantTokens 
} from '../services/api';
import { 
  // Modern wallet core imports
  useWallet,
  useWalletConnect,
  useWalletTransaction,
  useWalletDetection,
  useTokenBalance,
  useNetworkSwitch,
  ConnectButton,
  // Legacy imports for backward compatibility
  connectWallet, 
  sendTransaction, 
  detectWallets,
  getSupportedWalletsForNetwork,
  NETWORK_TYPES,
  WALLET_TYPES,
  isEvmNetwork
} from '../services/walletCoreService';

/**
 * Enhanced Coinley checkout with better error handling and direct connections
 */
const CoinleyCheckout = forwardRef(({ 
  apiKey,
  apiSecret,
  apiUrl,
  customerEmail,
  merchantName = 'Merchant',
  merchantWalletAddresses = {},
  onSuccess,
  onError,
  onClose,
  theme,
  autoOpen = false,
  debug = false,
  testMode = false,
  supportedNetworks = [],
  preferredNetwork = NETWORK_TYPES.ETHEREUM,
  preferredWallet = WALLET_TYPES.METAMASK,
  confirmations = 1,
  fastMode = true
}, ref) => {
  // Context
  const coinleyContext = useCoinley();
  const { theme: contextTheme } = useTheme();
  
  // Modern wallet core hooks (for EVM networks)
  const { 
    address: walletAddress, 
    isConnected: isWalletConnected, 
    chainId: currentChainId,
    balanceFormatted: nativeBalance,
    disconnect: disconnectWallet
  } = useWallet();
  
  const { connectWallet: connectEvmWallet, isPending: isConnecting } = useWalletConnect();
  const { sendTransaction: sendEvmTransaction, isPending: isSending } = useWalletTransaction();
  const { detectedWallets } = useWalletDetection();
  const { switchChain } = useNetworkSwitch();
  
  // State
  const [isOpen, setIsOpen] = useState(autoOpen);
  const [payment, setPayment] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState('idle');
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [error, setError] = useState(null);
  const [transactionHash, setTransactionHash] = useState(null);
  const [walletConnection, setWalletConnection] = useState(null);
  const [availableWallets, setAvailableWallets] = useState({});
  const [step, setStep] = useState('select-currency');
  const [actualMerchantWallets, setActualMerchantWallets] = useState({});
  const [merchantFeePercentage, setMerchantFeePercentage] = useState(0.0175);
  const [storedPaymentDetails, setStoredPaymentDetails] = useState(null);
  const [merchantSupportedNetworks, setMerchantSupportedNetworks] = useState([]);
  const [merchantSupportedTokens, setMerchantSupportedTokens] = useState([]);
  const [processingStartTime, setProcessingStartTime] = useState(null);
  const [pendingBackendConfirmation, setPendingBackendConfirmation] = useState(false);
  
  // Use the component props or fallback to context values
  const effectiveApiKey = apiKey || coinleyContext?.apiKey;
  const effectiveApiSecret = apiSecret || coinleyContext?.apiSecret;
  const effectiveApiUrl = apiUrl || coinleyContext?.apiUrl;
  const effectiveTheme = theme || contextTheme;
  const effectiveDebug = debug || coinleyContext?.debug;

  // Debug logging helper
  const log = (message, data) => {
    if (effectiveDebug) {
      console.log(`[Coinley SDK] ${message}`, data);
    }
  };

  // ✅ ENHANCED: Modern wallet detection with wallet-connect-core integration
  useEffect(() => {
    const detectWalletsEnhanced = async () => {
      try {
        log('Detecting wallets via wallet-connect-core and legacy methods...');
        
        // Combine modern detection (EVM wallets) with legacy detection (non-EVM)
        const [modernWallets, legacyWallets] = await Promise.allSettled([
          // Modern detection from wallet-connect-core
          Promise.resolve(detectedWallets || []),
          // Legacy detection for non-EVM wallets
          detectWallets()
        ]);
        
        // Convert modern detected wallets to the expected format
        const evmWallets = {};
        if (modernWallets.status === 'fulfilled' && modernWallets.value) {
          modernWallets.value.forEach(wallet => {
            if (wallet.name.toLowerCase().includes('metamask')) {
              evmWallets[WALLET_TYPES.METAMASK] = true;
            } else if (wallet.name.toLowerCase().includes('coinbase')) {
              evmWallets[WALLET_TYPES.COINBASE_WALLET] = true;
            } else if (wallet.name.toLowerCase().includes('trust')) {
              evmWallets[WALLET_TYPES.TRUST_WALLET] = true;
            }
          });
        }
        
        // Merge with legacy detection results
        const legacyResult = legacyWallets.status === 'fulfilled' ? legacyWallets.value : {};
        
        const allWallets = {
          ...legacyResult,
          ...evmWallets
        };
        
        setAvailableWallets(allWallets);
        log('Available wallets detected:', allWallets);
        
      } catch (error) {
        console.error('Error detecting wallets:', error);
        // Fallback to basic detection
        const fallbackWallets = {
          [WALLET_TYPES.METAMASK]: typeof window.ethereum !== 'undefined',
          [WALLET_TYPES.PHANTOM]: typeof window.solana !== 'undefined',
          [WALLET_TYPES.TRONLINK]: typeof window.tronWeb !== 'undefined',
          [WALLET_TYPES.TRUST_WALLET]: false,
          [WALLET_TYPES.LUTE]: false
        };
        setAvailableWallets(fallbackWallets);
        log('Using fallback wallet detection:', fallbackWallets);
      }
    };
    
    detectWalletsEnhanced();
  }, [effectiveDebug, detectedWallets]);

  // ✅ NEW: Sync wallet connection state with modern wallet core
  useEffect(() => {
    if (isWalletConnected && walletAddress && !walletConnection?.provider) {
      // Create wallet connection object from modern wallet state
      const modernConnection = {
        walletType: 'modern',
        address: walletAddress,
        network: selectedPaymentMethod?.network || 'ethereum',
        isConnected: isWalletConnected,
        chainId: currentChainId,
        provider: 'wallet-connect-core'
      };
      
      setWalletConnection(modernConnection);
      log('✅ Synced modern wallet connection state:', modernConnection);
    } else if (!isWalletConnected && walletConnection?.provider === 'wallet-connect-core') {
      // Clear connection if modern wallet disconnected
      setWalletConnection(null);
      log('✅ Cleared disconnected wallet connection state');
    }
  }, [isWalletConnected, walletAddress, currentChainId, selectedPaymentMethod?.network]);

  // ✅ ENHANCED: Better merchant data loading with error handling
  useEffect(() => {
    const fetchMerchantData = async () => {
      if (!effectiveApiKey || !effectiveApiSecret) {
        log('Missing API credentials, skipping merchant data fetch');
        return;
      }

      try {
        log('Fetching merchant data from backend...');
        
        const [wallets, feePercentage, networks, tokens] = await Promise.allSettled([
          getMerchantWallets(),
          getMerchantFeePercentage(),
          getMerchantNetworks(),
          getMerchantTokens()
        ]);
        
        // Handle wallets
        if (wallets.status === 'fulfilled') {
          setActualMerchantWallets(wallets.value || {});
          log('✅ Merchant wallets loaded:', Object.keys(wallets.value || {}));
        } else {
          console.warn('⚠️ Failed to load merchant wallets:', wallets.reason);
          setActualMerchantWallets(merchantWalletAddresses);
        }
        
        // Handle fee percentage
        if (feePercentage.status === 'fulfilled') {
          setMerchantFeePercentage(feePercentage.value || 0.0175);
          log('✅ Merchant fee percentage loaded:', `${((feePercentage.value || 0.0175) * 100).toFixed(2)}%`);
        } else {
          console.warn('⚠️ Failed to load merchant fee percentage:', feePercentage.reason);
          setMerchantFeePercentage(0.0175);
        }
        
        // Handle networks
        if (networks.status === 'fulfilled') {
          setMerchantSupportedNetworks(networks.value || []);
          log('✅ Merchant networks loaded:', networks.value?.length || 0);
        } else {
          console.warn('⚠️ Failed to load merchant networks:', networks.reason);
          setMerchantSupportedNetworks([]);
        }
        
        // Handle tokens
        if (tokens.status === 'fulfilled') {
          setMerchantSupportedTokens(tokens.value || []);
          log('✅ Merchant tokens loaded:', tokens.value?.length || 0);
        } else {
          console.warn('⚠️ Failed to load merchant tokens:', tokens.reason);
          setMerchantSupportedTokens([]);
        }
        
        log('Merchant data loading completed');
        
      } catch (error) {
        console.error('❌ Critical error fetching merchant data:', error);
        // Use fallback values
        setActualMerchantWallets(merchantWalletAddresses || {});
        setMerchantFeePercentage(0.0175);
        setMerchantSupportedNetworks([]);
        setMerchantSupportedTokens([]);
      }
    };

    fetchMerchantData();
  }, [effectiveApiKey, effectiveApiSecret, merchantWalletAddresses]);

  // Backend confirmation function
  const processBackendConfirmationWithDebug = async (txHash) => {
    console.log('🔍 processBackendConfirmationWithDebug called with:', txHash);
    
    if (!payment || !selectedPaymentMethod || !txHash) {
      console.error('❌ Missing required data for backend confirmation');
      return;
    }
    
    try {
      const processResponse = await processPayment({
        paymentId: payment.id,
        transactionHash: txHash,
        network: selectedPaymentMethod.network,
        senderAddress: walletConnection?.address || 'EXTERNAL_WALLET'
      });

      console.log('✅ Payment processed successfully with backend:', processResponse);
      setPendingBackendConfirmation(false);
      
      setPaymentStatus('success');
      
      if (onSuccess) {
        onSuccess(payment.id, txHash, {
          network: selectedPaymentMethod.network,
          currency: selectedPaymentMethod.currency,
          amount: payment.totalAmount || payment.amount,
          processResponse: processResponse
        });
      }
    } catch (processError) {
      console.error('❌ processBackendConfirmation failed:', processError);
      setPendingBackendConfirmation(true);
      
      setTimeout(() => {
        console.log('🔄 Retrying processBackendConfirmation...');
        processBackendConfirmationWithDebug(txHash);
      }, 10000);
    }
  };

  // QR Payment verification function
  const handleQRPaymentVerification = async () => {
    if (!payment) {
      setError('Payment information is missing');
      return;
    }

    setPaymentStatus('loading');
    setStep('processing');
    setProcessingStartTime(Date.now());
    setError(null);

    try {
      log('Starting QR payment verification...');
      
      const verificationResult = await verifyQRPayment(payment.id);
      
      if (verificationResult.verified) {
        log('QR payment verified successfully:', verificationResult);
        
        setTransactionHash(verificationResult.payment.transactionHash);
        setStep('success');
        setPaymentStatus('success');
        
        if (onSuccess) {
          onSuccess(payment.id, verificationResult.payment.transactionHash, {
            network: selectedPaymentMethod.network,
            currency: selectedPaymentMethod.currency,
            amount: verificationResult.payment.amount,
            verificationType: 'QR_PAYMENT'
          });
        }
      } else {
        setError(verificationResult.message || 'Transaction not detected yet. Please wait a moment and try again.');
        setStep('confirm');
        setPaymentStatus('idle');
      }
    } catch (error) {
      log('QR payment verification error:', error);
      setError(error.message || 'Failed to verify payment. Please try again.');
      setStep('confirm');
      setPaymentStatus('error');
      if (onError) onError(error);
    }
  };

  // Expose methods via ref
  useImperativeHandle(ref, () => ({
    open: (paymentDetails) => {
      handleOpen(paymentDetails);
    },
    close: () => {
      handleClose();
    },
    getPayment: () => payment,
    getWalletConnection: () => walletConnection,
    getMerchantWallets: () => actualMerchantWallets,
    getMerchantFeePercentage: () => merchantFeePercentage,
    getMerchantSupportedNetworks: () => merchantSupportedNetworks,
    getMerchantSupportedTokens: () => merchantSupportedTokens
  }));

  // Handle opening the payment modal
  const handleOpen = async (paymentDetails) => {
    console.log('🚨 HANDLE OPEN DEBUG - START');
    console.log('paymentDetails received:', paymentDetails);
    
    if (!paymentDetails || !paymentDetails.amount) {
      setError('Payment amount is required');
      if (onError) onError(new Error('Payment amount is required'));
      return;
    }

    setStoredPaymentDetails(paymentDetails);
    setPaymentStatus('idle');
    setIsOpen(true);
    setStep('select-currency');
    setError(null);
    
    console.log('✅ Modal opened, waiting for user to select payment method');
  };

  // Handle closing the modal
  const handleClose = () => {
    setIsOpen(false);
    setTransactionHash(null);
    setWalletConnection(null);
    setSelectedPaymentMethod(null);
    setStoredPaymentDetails(null);
    setPayment(null);
    setStep('select-currency');
    setProcessingStartTime(null);
    setPendingBackendConfirmation(false);
    
    if (onClose) onClose();
  };

  // Handle payment method selection
  const handlePaymentMethodSelect = async (paymentMethod) => {
    console.log('=== PAYMENT METHOD SELECTION DEBUG ===');
    console.log('1. Payment method selected:', paymentMethod);
    console.log('2. Stored payment details:', storedPaymentDetails);
    
    if (!storedPaymentDetails) {
      setError('Payment details are missing');
      return;
    }
    
    log('Payment method selected:', paymentMethod);
    setSelectedPaymentMethod(paymentMethod);
    
    // Create payment with the selected network/currency
    try {
      setPaymentStatus('loading');
      
      console.log('🚀 Creating payment with selected method:');
      console.log('Network:', paymentMethod.network);
      console.log('Currency:', paymentMethod.currency);
      
      // ✅ ENHANCED: Better validation with fallback
      let isNetworkSupported = false;
      let isTokenSupported = false;
      
      if (merchantSupportedNetworks.length > 0) {
        isNetworkSupported = merchantSupportedNetworks.some(
          network => network.shortName === paymentMethod.network
        );
      } else {
        // If no networks configured, allow basic networks
        isNetworkSupported = ['ethereum', 'bsc', 'solana'].includes(paymentMethod.network);
        console.warn('⚠️ No merchant networks configured, using fallback validation');
      }
      
      if (merchantSupportedTokens.length > 0) {
        isTokenSupported = merchantSupportedTokens.some(
          token => token.symbol === paymentMethod.currency && 
                  token.Network && 
                  token.Network.shortName === paymentMethod.network
        );
      } else {
        // If no tokens configured, allow basic stablecoins
        isTokenSupported = ['USDT', 'USDC'].includes(paymentMethod.currency);
        console.warn('⚠️ No merchant tokens configured, using fallback validation');
      }
      
      if (!isNetworkSupported) {
        throw new Error(`Network ${paymentMethod.network} is not configured for this merchant`);
      }
      
      if (!isTokenSupported) {
        throw new Error(`Token ${paymentMethod.currency} is not supported on ${paymentMethod.network} network for this merchant`);
      }
      
      // Ensure we have the latest merchant wallet addresses
      let walletAddresses = actualMerchantWallets;
      if (Object.keys(walletAddresses).length === 0) {
        log('No wallet addresses found, fetching from backend...');
        try {
          walletAddresses = await getMerchantWallets();
          setActualMerchantWallets(walletAddresses);
        } catch (error) {
          console.warn('⚠️ Failed to fetch wallet addresses:', error);
          walletAddresses = merchantWalletAddresses || {};
        }
      }

      log('Using wallet addresses:', walletAddresses);

      // Create payment with SELECTED network/currency
      const paymentResponse = await createPayment({
        amount: storedPaymentDetails.amount,
        currency: paymentMethod.currency,
        network: paymentMethod.network,
        customerEmail: storedPaymentDetails.customerEmail || customerEmail,
        callbackUrl: storedPaymentDetails.callbackUrl,
        metadata: {
          ...storedPaymentDetails.metadata,
          merchantWalletAddresses: walletAddresses
        },
        merchantWalletAddresses: walletAddresses
      });

      console.log('✅ Payment created with correct network:', paymentResponse.payment);
      
      // Use the fee percentage from the payment response
      if (paymentResponse.payment.customFeePercentage) {
        const feeFromPayment = parseFloat(paymentResponse.payment.customFeePercentage);
        setMerchantFeePercentage(feeFromPayment);
        log('Updated fee percentage from payment response:', `${(feeFromPayment * 100).toFixed(2)}%`);
      }
      
      setPayment(paymentResponse.payment);
      setPaymentStatus('idle');
      setError(null);
      
      // Now proceed to confirm step
      setStep('confirm');
      
      log('Payment created and proceeding to confirmation');
    } catch (err) {
      log('Error creating payment:', err);
      setError(err.message || 'Failed to create payment');
      setPaymentStatus('error');
      if (onError) onError(err);
    }
    
    console.log('=== END PAYMENT METHOD SELECTION DEBUG ===');
  };

  // Handle back navigation
  const handleBack = () => {
    if (step === 'confirm') {
      setStep('select-currency');
      setWalletConnection(null);
      setPayment(null);
      setSelectedPaymentMethod(null);
    } else if (step === 'error') {
      setStep('confirm');
    }
  };

  // ✅ ENHANCED: Modern wallet connection with wallet-connect-core integration
  const handleConnectWallet = async (walletType) => {
    console.log('🔗 Connecting wallet with modern core:', walletType);

    if (!selectedPaymentMethod) {
      console.error('No payment method selected');
      setError('Please select a payment method first');
      return;
    }

    try {
      setError(null);
      
      // Check if it's an EVM network that can use wallet-connect-core
      if (isEvmNetwork(selectedPaymentMethod.network)) {
        log('Using modern wallet-connect-core for EVM network:', selectedPaymentMethod.network);
        
        // Use modern wallet core for EVM networks
        try {
          await connectEvmWallet(walletType);
          
          // Create connection object for compatibility
          const connection = {
            walletType,
            address: walletAddress,
            network: selectedPaymentMethod.network,
            isConnected: isWalletConnected,
            chainId: currentChainId,
            provider: 'wallet-connect-core'
          };
          
          setWalletConnection(connection);
          log('🎉 Modern wallet connected successfully!', connection);
          
        } catch (evmError) {
          log('Modern connection failed, trying legacy fallback...');
          throw evmError;
        }
      } else {
        // Use legacy connection for non-EVM networks
        log('Using legacy connection for non-EVM network:', selectedPaymentMethod.network);
        const connection = await connectWallet(walletType, selectedPaymentMethod.network);
        setWalletConnection(connection);
        log('🎉 Legacy wallet connected successfully!', connection);
      }
      
      setError(null);
      
    } catch (err) {
      console.error('❌ Wallet connection error:', err);
      setError(err.message || 'Failed to connect wallet');
    }
  };

  // ✅ ENHANCED: Better payment handling
  const handlePayment = async (isQRPayment = false) => {
    if (!payment || !selectedPaymentMethod) {
      setError('Missing payment information');
      return;
    }

    // Handle QR payment verification
    if (isQRPayment) {
      console.log('🔄 QR Payment - Starting verification process...');
      await handleQRPaymentVerification();
      return;
    }

    // Wallet payment flow
    if (!walletConnection && !testMode) {
      setError('Please connect your wallet first');
      return;
    }

    log('Starting payment process...');
    setPaymentStatus('loading');
    setTransactionHash(null);
    setStep('processing');
    setProcessingStartTime(Date.now());

    try {
      let txHash;

      if (testMode) {
        log('Test mode: Generating mock transaction...');
        txHash = `test_${Date.now().toString(16)}_${Math.random().toString(16).substring(2, 10)}`;
        await new Promise(resolve => setTimeout(resolve, 1000));
      } else {
        let merchantAddress;
        
        if (payment.recipientWallet) {
          merchantAddress = payment.recipientWallet;
        } else if (actualMerchantWallets[selectedPaymentMethod.network]) {
          merchantAddress = actualMerchantWallets[selectedPaymentMethod.network];
        } else {
          throw new Error(`No merchant wallet address found for ${selectedPaymentMethod.network} network`);
        }

        log('Using merchant address for payment:', merchantAddress);
        log('Sending transaction...');
        
        // ✅ Use modern or legacy transaction sending based on network type
        if (isEvmNetwork(selectedPaymentMethod.network) && walletConnection?.provider === 'wallet-connect-core') {
          log('Using modern wallet-connect-core transaction...');
          
          // For EVM networks, use modern transaction hook
          try {
            txHash = await sendEvmTransaction({
              to: merchantAddress,
              value: selectedPaymentMethod.tokenConfig?.address ? '0x0' : 
                     `0x${(parseFloat(payment.totalAmount || payment.amount) * Math.pow(10, 18)).toString(16)}`,
              data: selectedPaymentMethod.tokenConfig?.address ? 
                    // Token transfer data would go here (ERC-20 transfer)
                    '0x' : undefined
            });
          } catch (evmTxError) {
            log('Modern transaction failed, falling back to legacy...');
            throw evmTxError;
          }
        } else {
          // Use legacy transaction function for non-EVM or fallback
          log('Using legacy transaction method...');
          txHash = await sendTransaction(walletConnection, {
            to: merchantAddress,
            amount: payment.totalAmount || payment.amount,
            tokenAddress: selectedPaymentMethod.tokenConfig?.address,
            tokenDecimals: selectedPaymentMethod.tokenConfig?.decimals,
            currency: selectedPaymentMethod.currency,
            network: selectedPaymentMethod.network
          });
        }
      }

      console.log('🎉 TRANSACTION HASH OBTAINED:', txHash);
      setTransactionHash(txHash);
      
      console.log('📺 Setting step to success...');
      setStep('success');
      setPaymentStatus('success');
      
      console.log('🔄 About to call processBackendConfirmation...');
      
      try {
        console.log('🚀 CALLING processBackendConfirmation...');
        await processBackendConfirmationWithDebug(txHash);
      } catch (processError) {
        console.error('❌ processBackendConfirmation failed:', processError);
      }
      
    } catch (err) {
      log('Payment error:', err);
      setError(err.message || 'Failed to process payment');
      setPaymentStatus('error');
      setStep('error');
      if (onError) onError(err);
    }
  };

  // Get supported wallets for current network
  const getSupportedWallets = () => {
    if (!selectedPaymentMethod) return [];
    return getSupportedWalletsForNetwork(selectedPaymentMethod.network);
  };

  // ✅ ENHANCED: Better network filtering with fallbacks
  const getEffectiveSupportedNetworks = () => {
    if (merchantSupportedNetworks.length === 0) {
      console.warn('⚠️ No merchant networks configured, using fallback networks');
      if (supportedNetworks.length > 0) {
        return supportedNetworks;
      }
      // Ultimate fallback
      return ['ethereum', 'bsc', 'solana'];
    }
    
    return merchantSupportedNetworks.map(network => network.shortName);
  };

  return (
    <>
      {isOpen && (
        <CoinleyModal
          isOpen={isOpen}
          onClose={handleClose}
          payment={payment}
          paymentStatus={paymentStatus}
          selectedPaymentMethod={selectedPaymentMethod}
          onPaymentMethodSelect={handlePaymentMethodSelect}
          onPayment={handlePayment}
          onBack={handleBack}
          error={error}
          theme={effectiveTheme}
          merchantName={merchantName}
          transactionHash={transactionHash}
          walletConnection={walletConnection}
          onConnectWallet={handleConnectWallet}
          testMode={testMode}
          supportedNetworks={getEffectiveSupportedNetworks()}
          availableWallets={availableWallets}
          supportedWallets={getSupportedWallets()}
          step={step}
          merchantWalletAddresses={actualMerchantWallets}
          debug={effectiveDebug}
          processingStartTime={processingStartTime}
          pendingBackendConfirmation={pendingBackendConfirmation}
          paymentNetwork={selectedPaymentMethod?.network}
          merchantFeePercentage={merchantFeePercentage}
        />
      )}
    </>
  );
});

CoinleyCheckout.displayName = 'CoinleyCheckout';

export default CoinleyCheckout;